
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("9eydB", function(module, exports) {
$parcel$export(module.exports, "captionPlugin", () => (parcelRequire("duFi2")).default);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $duFi2 = parcelRequire("duFi2");


});

parcelRegister("4Vpub", function(module, exports) {
$parcel$export(module.exports, "datePlugin", () => (parcelRequire("4iQt6")).default);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $4iQt6 = parcelRequire("4iQt6");


});

parcelRegister("58fnx", function(module, exports) {
$parcel$export(module.exports, "guidelinePlugin", () => (parcelRequire("fCLXZ")).guidelinePlugin);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $fCLXZ = parcelRequire("fCLXZ");


});

parcelRegister("d5BeT", function(module, exports) {
$parcel$export(module.exports, "helpDialogPlugin", () => (parcelRequire("flknw")).helpDialogPlugin);
$parcel$export(module.exports, "deprecatedOpenHelpCommand", () => (parcelRequire("bQUgf")).openHelpCommand);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $bQUgf = parcelRequire("bQUgf");

var $flknw = parcelRequire("flknw");


});

parcelRegister("6N2nV", function(module, exports) {
$parcel$export(module.exports, "mediaPlugin", () => (parcelRequire("cWFvG")).mediaPlugin);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $cWFvG = parcelRequire("cWFvG");


});

parcelRegister("dU3Nv", function(module, exports) {
$parcel$export(module.exports, "mediaInsertPlugin", () => (parcelRequire("2U68K")).mediaInsertPlugin);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $2U68K = parcelRequire("2U68K");


});

parcelRegister("8WOs1", function(module, exports) {
$parcel$export(module.exports, "placeholderTextPlugin", () => (parcelRequire("8HLyI")).default);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $8HLyI = parcelRequire("8HLyI");


});

parcelRegister("ii4wo", function(module, exports) {
$parcel$export(module.exports, "statusPlugin", () => (parcelRequire("c8680")).statusPlugin);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $c8680 = parcelRequire("c8680");


});

parcelRegister("1t2ub", function(module, exports) {
$parcel$export(module.exports, "contentInsertionPlugin", () => (parcelRequire("2yr9J")).contentInsertionPlugin);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $2yr9J = parcelRequire("2yr9J");


});

parcelRegister("1crCh", function(module, exports) {
$parcel$export(module.exports, "expandPlugin", () => (parcelRequire("fTvEN")).expandPlugin);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $fTvEN = parcelRequire("fTvEN");


});

parcelRegister("dcNOI", function(module, exports) {
$parcel$export(module.exports, "layoutPlugin", () => (parcelRequire("05jmd")).layoutPlugin);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $05jmd = parcelRequire("05jmd");


});

parcelRegister("fdbx8", function(module, exports) {
$parcel$export(module.exports, "panelPlugin", () => (parcelRequire("b3BjA")).default);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $b3BjA = parcelRequire("b3BjA");


});

parcelRegister("1C8xV", function(module, exports) {
$parcel$export(module.exports, "rulePlugin", () => (parcelRequire("5DsxN")).rulePlugin);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $5DsxN = parcelRequire("5DsxN");


});

parcelRegister("ituSb", function(module, exports) {
$parcel$export(module.exports, "tablesPlugin", () => (parcelRequire("eeGWn")).default);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $eeGWn = parcelRequire("eeGWn");


});

parcelRegister("i0V8C", function(module, exports) {
$parcel$export(module.exports, "tasksAndDecisionsPlugin", () => (parcelRequire("jaskt")).tasksAndDecisionsPlugin);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $jaskt = parcelRequire("jaskt");


});

parcelRegister("fvSfu", function(module, exports) {
$parcel$export(module.exports, "default", () => $187fe05e1f85bcab$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");


var $7541v = parcelRequire("7541v");


var $NPJKR = parcelRequire("NPJKR");



// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $3ihIB = parcelRequire("3ihIB");



parcelRequire("arL2z");
var $hr8mu = parcelRequire("hr8mu");

parcelRequire("6ukH4");
var $cpn0f = parcelRequire("cpn0f");



// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $PJ00O = parcelRequire("PJ00O");





// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $fPXRH = parcelRequire("fPXRH");





// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $ksXET = parcelRequire("ksXET");





// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $hSJYu = parcelRequire("hSJYu");



parcelRequire("9sDYf");
var $cwPVT = parcelRequire("cwPVT");

parcelRequire("9eydB");
var $duFi2 = parcelRequire("duFi2");


var $j5BTD = parcelRequire("j5BTD");



// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $01uqX = parcelRequire("01uqX");





// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $5AZDw = parcelRequire("5AZDw");



parcelRequire("1t2ub");
var $2yr9J = parcelRequire("2yr9J");

parcelRequire("8ElOg");
var $1nZXu = parcelRequire("1nZXu");



// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $bS1lJ = parcelRequire("bS1lJ");





// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $2nH2Y = parcelRequire("2nH2Y");



parcelRequire("4Vpub");
var $4iQt6 = parcelRequire("4iQt6");


var $8uNa8 = parcelRequire("8uNa8");

parcelRequire("1crCh");
var $fTvEN = parcelRequire("fTvEN");

parcelRequire("aAppb");
var $eyggb = parcelRequire("eyggb");



// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $3Vesv = parcelRequire("3Vesv");





// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $dtCIm = parcelRequire("dtCIm");





// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $6q6xk = parcelRequire("6q6xk");




var $bn2AM = parcelRequire("bn2AM");

parcelRequire("58fnx");
var $fCLXZ = parcelRequire("fCLXZ");

parcelRequire("d5BeT");
var $flknw = parcelRequire("flknw");



// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $kwFBr = parcelRequire("kwFBr");




var $8POG7 = parcelRequire("8POG7");


var $5zfRA = parcelRequire("5zfRA");

parcelRequire("dcNOI");
var $05jmd = parcelRequire("05jmd");


var $88OoA = parcelRequire("88OoA");



// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $h8AH9 = parcelRequire("h8AH9");



parcelRequire("6N2nV");
var $cWFvG = parcelRequire("cWFvG");

parcelRequire("dU3Nv");
var $2U68K = parcelRequire("2U68K");


var $dhgPE = parcelRequire("dhgPE");

parcelRequire("fdbx8");
var $b3BjA = parcelRequire("b3BjA");



// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $59fTa = parcelRequire("59fTa");



parcelRequire("8WOs1");
var $8HLyI = parcelRequire("8HLyI");

parcelRequire("1C8xV");
var $5DsxN = parcelRequire("5DsxN");


var $kPcbV = parcelRequire("kPcbV");



// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $1GAIu = parcelRequire("1GAIu");



parcelRequire("ii4wo");
var $c8680 = parcelRequire("c8680");



// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $efDik = parcelRequire("efDik");



parcelRequire("ituSb");
var $eeGWn = parcelRequire("eeGWn");

parcelRequire("i0V8C");
var $jaskt = parcelRequire("jaskt");


var $gcsWd = parcelRequire("gcsWd");


var $fH5dz = parcelRequire("fH5dz");



// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $bz4KD = parcelRequire("bz4KD");




var $1oCLl = parcelRequire("1oCLl");


var $iu6m9 = parcelRequire("iu6m9");


var $geLSP = parcelRequire("geLSP");


var $75KVc = parcelRequire("75KVc");


var $gVoWJ = parcelRequire("gVoWJ");

function $09f6088b2411e2a8$export$2e2bcd8739ae039({ appearance: appearance, props: props, featureFlags: featureFlags, initialPluginConfiguration: initialPluginConfiguration, prevAppearance: prevAppearance, createAnalyticsEvent: createAnalyticsEvent }) {
    const isComment = appearance === 'comment';
    const isChromeless = appearance === 'chromeless';
    const isFullPage = (0, $geLSP.isFullPage)(appearance);
    const getEditorFeatureFlags = ()=>featureFlags;
    const defaultPreset = (0, $gVoWJ.createDefaultPreset)({
        ...props,
        appearance: appearance,
        createAnalyticsEvent: createAnalyticsEvent,
        hyperlinkOptions: {
            lpLinkPicker: featureFlags.lpLinkPicker ?? false,
            ...props.hyperlinkOptions
        },
        __livePage: props.__livePage,
        toolbar: initialPluginConfiguration?.toolbarPlugin
    });
    const statusMenuDisabled = !props.allowStatus ? true : typeof props.allowStatus === 'object' ? Boolean(props.allowStatus.menuDisabled) : false;
    const hasBeforePrimaryToolbar = (components)=>{
        if (components && 'before' in components) return !!components.before;
        return false;
    };
    const finalPreset = defaultPreset.add((0, $bz4KD.ufoPlugin)).add((0, $2nH2Y.dataConsumerPlugin)).add((0, $3ihIB.accessibilityUtilsPlugin)).add((0, $2yr9J.contentInsertionPlugin)).add((0, $fPXRH.batchAttributeUpdatesPlugin)).maybeAdd([
        (0, $cwPVT.breakoutPlugin),
        {
            allowBreakoutButton: appearance === 'full-page',
            appearance: appearance
        }
    ], Boolean(props.allowBreakout && isFullPage)).maybeAdd((0, $hr8mu.alignmentPlugin), Boolean(props.allowTextAlignment)).maybeAdd([
        (0, $gcsWd.textColorPlugin),
        props.allowTextColor
    ], Boolean(props.allowTextColor)).add((0, $88OoA.listPlugin)).maybeAdd((0, $5DsxN.rulePlugin), Boolean(props.allowRule)).maybeAdd([
        (0, $fTvEN.expandPlugin),
        {
            allowInsertion: $09f6088b2411e2a8$export$a9b5e68d7107c3df(props),
            useLongPressSelection: false,
            appearance: appearance,
            allowInteractiveExpand: typeof props.allowExpand === 'boolean' ? props.allowExpand : Boolean(props.allowExpand && props.allowExpand.allowInteractiveExpand !== false),
            __livePage: props.__livePage
        }
    ], Boolean(props.allowExpand)).maybeAdd((0, $fCLXZ.guidelinePlugin), Boolean(!isComment && !isChromeless && (props.media || props.allowTables) || (0, $iu6m9.editorExperiment)('platform_editor_breakout_resizing', true, {
        exposure: true
    }) && (props.allowExpand || props.allowLayouts || props.codeBlock))).maybeAdd([
        (0, $bn2AM.gridPlugin),
        {
            shouldCalcBreakoutGridLines: isFullPage
        }
    ], Boolean(props.media)).maybeAdd([
        (0, $cpn0f.annotationPlugin),
        props.annotationProviders
    ], Boolean(props.annotationProviders)).maybeAdd([
        (0, $cWFvG.mediaPlugin),
        {
            ...props.media,
            allowLazyLoading: true,
            allowBreakoutSnapPoints: isFullPage,
            allowAdvancedToolBarOptions: typeof props.media?.allowAdvancedToolBarOptions !== 'undefined' ? props.media?.allowAdvancedToolBarOptions : isFullPage || isComment,
            allowCommentsOnMedia: isFullPage && Boolean(props.annotationProviders),
            allowDropzoneDropLine: isFullPage,
            allowMediaSingleEditable: true,
            allowRemoteDimensionsFetch: true,
            allowMarkingUploadsAsIncomplete: false,
            allowImagePreview: typeof props.media?.allowImagePreview !== 'undefined' ? props.media?.allowImagePreview : isFullPage,
            fullWidthEnabled: appearance === 'full-width',
            editorAppearance: appearance,
            uploadErrorHandler: props.uploadErrorHandler,
            waitForMediaUpload: props.waitForMediaUpload,
            isCopyPasteEnabled: true,
            alignLeftOnInsert: typeof props.media?.alignLeftOnInsert !== 'undefined' ? props.media?.alignLeftOnInsert : isComment,
            getEditorFeatureFlags: getEditorFeatureFlags
        }
    ], Boolean(props.media)).maybeAdd((0, $2U68K.mediaInsertPlugin), Boolean(props.media)).maybeAdd((0, $duFi2.default), Boolean(props.media?.allowCaptions)).maybeAdd([
        (0, $dhgPE.mentionsPlugin),
        {
            sanitizePrivateContent: props.sanitizePrivateContent,
            insertDisplayName: props.mention?.insertDisplayName ?? props.mentionInsertDisplayName,
            allowZeroWidthSpaceAfter: true,
            HighlightComponent: props.mention?.HighlightComponent,
            profilecardProvider: props.mention?.profilecardProvider,
            mentionProvider: props.mentionProvider,
            ...initialPluginConfiguration?.mentionsPlugin
        }
    ], Boolean(props.mentionProvider)).maybeAdd([
        (0, $8uNa8.emojiPlugin),
        {
            emojiProvider: props.emojiProvider,
            ...(0, $1oCLl.expValEquals)('platform_editor_plain_text_support', 'isEnabled', true) ? initialPluginConfiguration?.emojiPlugin : {}
        }
    ], Boolean(props.emojiProvider)).maybeAdd([
        (0, $eeGWn.default),
        {
            tableOptions: !props.allowTables || typeof props.allowTables === 'boolean' ? {} : props.allowTables,
            dragAndDropEnabled: featureFlags?.tableDragAndDrop && (isFullPage || (isComment || isChromeless) && (0, $iu6m9.editorExperiment)('support_table_in_comment', true, {
                exposure: true
            })) || isComment && (0, $iu6m9.editorExperiment)('support_table_in_comment_jira', true, {
                exposure: true
            }),
            isTableScalingEnabled: isFullPage || isComment && (0, $iu6m9.editorExperiment)('support_table_in_comment', true, {
                exposure: true
            }) || isComment && (0, $iu6m9.editorExperiment)('support_table_in_comment_jira', true, {
                exposure: true
            }),
            allowContextualMenu: true,
            fullWidthEnabled: appearance === 'full-width',
            wasFullWidthEnabled: prevAppearance && prevAppearance === 'full-width',
            getEditorFeatureFlags: getEditorFeatureFlags,
            isCommentEditor: isComment,
            isChromelessEditor: isChromeless
        }
    ], Boolean(props.allowTables)).maybeAdd([
        (0, $jaskt.tasksAndDecisionsPlugin),
        {
            allowNestedTasks: props.allowNestedTasks,
            consumeTabs: isFullPage,
            useLongPressSelection: false,
            taskDecisionProvider: props.taskDecisionProvider,
            ...initialPluginConfiguration?.tasksAndDecisionsPlugin
        }
    ], Boolean(props.allowTasksAndDecisions || props.taskDecisionProvider)).maybeAdd([
        (0, $3Vesv.feedbackDialogPlugin),
        {
            coreVersion: $75KVc.version,
            ...props.feedbackInfo
        }
    ], Boolean(props.feedbackInfo)).maybeAdd([
        (0, $flknw.helpDialogPlugin),
        !!props.legacyImageUploadProvider
    ], Boolean(props.allowHelpDialog)).maybeAdd([
        (0, $kPcbV.saveOnEnterPlugin),
        props.onSave
    ], Boolean(props.saveOnEnter && props.onSave)).maybeAdd((0, $kwFBr.imageUploadPlugin), Boolean(props.legacyImageUploadProvider)).maybeAdd(// duplicate plugin exists because first one if media is enabled
    // second one when “media is disabled, and legacyMediaProvider is enabled
    // @ts-expect-error
    [
        (0, $cWFvG.mediaPlugin),
        {
            allowMediaSingle: {
                disableLayout: true
            },
            allowMediaGroup: false,
            isCopyPasteEnabled: true
        }
    ], Boolean(props.legacyImageUploadProvider && !props.media)).maybeAdd([
        (0, $5AZDw.collabEditPlugin),
        {
            ...props.collabEdit,
            sanitizePrivateContent: props.sanitizePrivateContent,
            EXPERIMENTAL_allowInternalErrorAnalytics: props.collabEdit?.EXPERIMENTAL_allowInternalErrorAnalytics ?? (0, $NPJKR.shouldForceTracking)()
        }
    ], Boolean(props.collabEdit || props.collabEditProvider)).maybeAdd([
        (0, $h8AH9.default),
        props.maxContentSize
    ], Boolean(props.maxContentSize)).maybeAdd([
        (0, $b3BjA.default),
        {
            useLongPressSelection: false,
            allowCustomPanel: typeof props.allowPanel === 'object' ? props.allowPanel.allowCustomPanel : false,
            allowCustomPanelEdit: typeof props.allowPanel === 'object' ? props.allowPanel.allowCustomPanelEdit : false
        }
    ], Boolean(props.allowPanel)).maybeAdd((0, $1nZXu.contextPanelPlugin), Boolean(isFullPage)).maybeAdd([
        (0, $eyggb.extensionPlugin),
        {
            breakoutEnabled: appearance === 'full-page' && (typeof props.allowExtension === 'object' ? props.allowExtension.allowBreakout : true) !== false,
            extensionHandlers: props.extensionHandlers,
            useLongPressSelection: false,
            appearance: appearance,
            ...initialPluginConfiguration?.extensionPlugin
        }
    ], Boolean(props.allowExtension)).maybeAdd(// we are ignoring a duplicate plugin error here
    // this error exists because we have two annotation plugins being added
    // one with annotationProviders and one with allowConfluenceInlineComment
    // long term this and media should be consolidated into adding both only once
    // @ts-expect-error
    [
        (0, $cpn0f.annotationPlugin),
        undefined
    ], Boolean(!props.annotationProviders && props.allowConfluenceInlineComment)).maybeAdd([
        (0, $4iQt6.default),
        {
            weekStartDay: typeof props.allowDate === 'object' ? props.allowDate.weekStartDay : undefined
        }
    ], Boolean(props.allowDate)).maybeAdd([
        (0, $8HLyI.default),
        // @ts-expect-error 2322: Type 'false | PlaceholderTextOptions | undefined'
        props.allowTemplatePlaceholders !== true ? props.allowTemplatePlaceholders : {}
    ], Boolean(props.allowTemplatePlaceholders)).maybeAdd([
        (0, $05jmd.layoutPlugin),
        {
            ...typeof props.allowLayouts === 'object' ? props.allowLayouts : {},
            useLongPressSelection: false,
            UNSAFE_allowSingleColumnLayout: typeof props.allowLayouts === 'object' ? props.allowLayouts.UNSAFE_allowSingleColumnLayout : undefined,
            editorAppearance: appearance
        }
    ], Boolean(props.allowLayouts)).maybeAdd([
        (0, $j5BTD.cardPlugin),
        {
            ...props.UNSAFE_cards,
            ...props.smartLinks,
            ...props.linking?.smartLinks,
            fullWidthMode: appearance === 'full-width',
            linkPicker: props.linking?.linkPicker,
            lpLinkPicker: featureFlags.lpLinkPicker ?? false,
            editorAppearance: appearance,
            // @ts-ignore Temporary solution to check for Live Page editor.
            __livePage: props.__livePage
        }
    ], Boolean(props.linking?.smartLinks || props.smartLinks || props.UNSAFE_cards)).maybeAdd([
        (0, $bS1lJ.customAutoformatPlugin),
        {
            autoformattingProvider: props.autoformattingProvider
        }
    ], Boolean(props.autoformattingProvider)).maybeAdd([
        (0, $c8680.statusPlugin),
        {
            menuDisabled: statusMenuDisabled,
            allowZeroWidthSpaceAfter: true
        }
    ], Boolean(props.allowStatus)).maybeAdd([
        (0, $efDik.syncedBlockPlugin),
        props.syncBlock
    ], Boolean(props.syncBlock) && (0, $1oCLl.expValEquals)('platform_synced_block', 'isEnabled', true)).maybeAdd((0, $8POG7.indentationPlugin), Boolean(props.allowIndentation)).maybeAdd((0, $1GAIu.scrollIntoViewPlugin), Boolean(props.autoScrollIntoView !== false)).add([
        (0, $fH5dz.toolbarListsIndentationPlugin),
        {
            showIndentationButtons: !!props.showIndentationButtons,
            allowHeadingAndParagraphIndentation: !!props.allowIndentation
        }
    ]).add([
        (0, $5zfRA.insertBlockPlugin),
        {
            allowTables: !!props.allowTables,
            allowExpand: $09f6088b2411e2a8$export$a9b5e68d7107c3df(props),
            insertMenuItems: props.insertMenuItems,
            horizontalRuleEnabled: props.allowRule,
            tableSelectorSupported: featureFlags?.tableSelector && isFullPage,
            nativeStatusSupported: !statusMenuDisabled,
            showElementBrowserLink: props.elementBrowser && props.elementBrowser.showModal || false,
            appearance: appearance,
            ...initialPluginConfiguration?.insertBlockPlugin
        }
    ]).maybeAdd([
        (0, $ksXET.beforePrimaryToolbarPlugin),
        {
            beforePrimaryToolbarComponents: // @ts-expect-error 2339: Property 'before' does not exist on type 'PrimaryToolbarComponents'.
            props.primaryToolbarComponents?.before
        }
    ], Boolean(hasBeforePrimaryToolbar(props.primaryToolbarComponents) && !featureFlags.twoLineEditorToolbar)).add([
        (0, $PJ00O.avatarGroupPlugin),
        {
            // Avatars are moved to Confluence codebase for Edit in Context
            // When Edit in Context is enabled primaryToolbarComponents is undefined
            // For more details please check
            // https://hello.atlassian.net/wiki/spaces/PCG/pages/2851572180/Editor+toolbar+for+live+pages+and+edit+in+context+projects
            collabEdit: props.collabEdit,
            takeFullWidth: !hasBeforePrimaryToolbar(props.primaryToolbarComponents),
            showAvatarGroup: featureFlags.showAvatarGroupAsPlugin === true && !featureFlags.twoLineEditorToolbar
        }
    ]).maybeAdd([
        (0, $dtCIm.findReplacePlugin),
        {
            takeFullWidth: !!featureFlags.showAvatarGroupAsPlugin === false && !hasBeforePrimaryToolbar(props.primaryToolbarComponents),
            twoLineEditorToolbar: !!props.primaryToolbarComponents && !!featureFlags.twoLineEditorToolbar
        }
    ], Boolean(props.allowFindReplace)).maybeAdd((0, $hSJYu.borderPlugin), Boolean(props.allowBorderMark)).maybeAdd((0, $6q6xk.fragmentPlugin), Boolean(props.allowFragmentMark)).add((0, $59fTa.pasteOptionsToolbarPlugin)).add([
        (0, $01uqX.codeBidiWarningPlugin),
        {
            appearance: appearance
        }
    ]);
    return finalPreset;
}
function $09f6088b2411e2a8$export$a9b5e68d7107c3df({ allowExpand: allowExpand }) {
    if (allowExpand && typeof allowExpand === 'object') return !!allowExpand.allowInsertion;
    return false;
}



var $6DQRK = parcelRequire("6DQRK");


var $1B55v = parcelRequire("1B55v");

function $0b00a5fce53402e3$export$28b0115d03e9c7ad({ props: props, prevProps: prevProps, initialPluginConfiguration: initialPluginConfiguration }) {
    return (0, $09f6088b2411e2a8$export$2e2bcd8739ae039)({
        appearance: props.appearance,
        props: (0, $1B55v.getDefaultPresetOptionsFromEditorProps)(props),
        initialPluginConfiguration: initialPluginConfiguration,
        featureFlags: (0, $6DQRK.createFeatureFlagsFromProps)(props.featureFlags),
        prevAppearance: prevProps?.appearance
    });
}


function $4baffa82d2587726$export$79c7ce3012e5b8c8(props, nextProps) {
    const properties = [
        'appearance',
        'persistScrollGutter',
        'allowUndoRedoButtons',
        'placeholder',
        'sanitizePrivateContent'
    ];
    return properties.reduce((acc, curr)=>acc || props[curr] !== nextProps[curr], false);
}


function $187fe05e1f85bcab$export$2e2bcd8739ae039({ props: props, initialPluginConfiguration: initialPluginConfiguration }) {
    const previousEditorProps = (0, $7541v.default)(props);
    const [preset, setPreset] = (0, $42omo.useState)(()=>(0, $0b00a5fce53402e3$export$28b0115d03e9c7ad)({
            props: props,
            prevProps: previousEditorProps,
            initialPluginConfiguration: initialPluginConfiguration
        }));
    (0, $42omo.useLayoutEffect)(()=>{
        if (!previousEditorProps) return;
        const recreate = (0, $4baffa82d2587726$export$79c7ce3012e5b8c8)(previousEditorProps, props);
        if (!recreate) return;
        // we are not comparing the previous initialPluginConfiguration to the new one assuming that it never changes
        setPreset((0, $0b00a5fce53402e3$export$28b0115d03e9c7ad)({
            props: props,
            prevProps: previousEditorProps,
            initialPluginConfiguration: initialPluginConfiguration
        }));
    }, [
        props,
        previousEditorProps,
        initialPluginConfiguration
    ]);
    return preset;
}

});

parcelRegister("arL2z", function(module, exports) {
$parcel$export(module.exports, "alignmentPlugin", () => (parcelRequire("hr8mu")).alignmentPlugin);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $hr8mu = parcelRequire("hr8mu");


});

parcelRegister("6ukH4", function(module, exports) {
$parcel$export(module.exports, "annotationPlugin", () => (parcelRequire("cpn0f")).annotationPlugin);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $cpn0f = parcelRequire("cpn0f");


});

parcelRegister("ksXET", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");

/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $9K4OG = parcelRequire("9K4OG");

function $63d636b872f679dd$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $63d636b872f679dd$var$beforePrimaryToolbarPluginWrapperStyles = {
    name: "4jjuk5",
    styles: "display:flex;margin-right:var(--ds-space-100, 8px);flex-grow:1;justify-content:flex-end;align-items:center"
};
const $63d636b872f679dd$export$b41281e8d2acb8ab = (props)=>/*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: $63d636b872f679dd$var$beforePrimaryToolbarPluginWrapperStyles,
        "data-testid": 'before-primary-toolbar-components-plugin'
    }, props.beforePrimaryToolbarComponents);


const $31299d1e32261be8$export$66dff0ee14673555 = ({ api: api, config: props })=>{
    const primaryToolbarComponent = ()=>{
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $63d636b872f679dd$export$b41281e8d2acb8ab), {
            beforePrimaryToolbarComponents: props?.beforePrimaryToolbarComponents
        });
    };
    api?.primaryToolbar?.actions.registerComponent({
        name: 'beforePrimaryToolbar',
        component: primaryToolbarComponent
    });
    return {
        name: 'beforePrimaryToolbar',
        primaryToolbarComponent: !api?.primaryToolbar ? primaryToolbarComponent : undefined
    };
};
module.exports["beforePrimaryToolbarPlugin"] = $31299d1e32261be8$export$66dff0ee14673555;

});

parcelRegister("9sDYf", function(module, exports) {
$parcel$export(module.exports, "breakoutPlugin", () => (parcelRequire("cwPVT")).breakoutPlugin);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $cwPVT = parcelRequire("cwPVT");


});

parcelRegister("5AZDw", function(module, exports) {

var $d925B = parcelRequire("d925B");


var $2pjJ5 = parcelRequire("2pjJ5");


var $h9yJL = parcelRequire("h9yJL");


var $aXG5V = parcelRequire("aXG5V");


var $9NwnH = parcelRequire("9NwnH");


var $1oCLl = parcelRequire("1oCLl");


var $iu6m9 = parcelRequire("iu6m9");





var $56Wjx = parcelRequire("56Wjx");


var $1HVk8 = parcelRequire("1HVk8");

const $469073082c3fe329$export$8c408a1f4e12c948 = (state, tr, featureFlags, editorAnalyticsApi)=>{
    return (error)=>{
        const browserExtensions = (0, $1HVk8.sniffUserBrowserExtensions)({
            extensions: [
                'grammarly'
            ]
        });
        const payload = {
            action: (0, $d925B.ACTION).SYNCHRONY_ERROR,
            actionSubject: (0, $d925B.ACTION_SUBJECT).EDITOR,
            eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
            attributes: {
                error: error,
                browserExtensions: browserExtensions
            }
        };
        if (featureFlags.synchronyErrorDocStructure) // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        payload.attributes.docStructure = (0, $56Wjx.getDocStructure)(state.doc, {
            compact: true
        });
        editorAnalyticsApi?.attachAnalyticsEvent(payload)(tr);
        return tr;
    };
};
const $469073082c3fe329$export$31cf0e3f119813a1 = (state, tr)=>{
    return (type, editorAnalyticsApi)=>{
        editorAnalyticsApi?.attachAnalyticsEvent({
            action: type === 'error' ? (0, $d925B.ACTION).SYNCHRONY_ENTITY_ERROR : (0, $d925B.ACTION).SYNCHRONY_DISCONNECTED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).EDITOR,
            eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
            attributes: {
                // https://developer.mozilla.org/en-US/docs/Web/API/NavigatorOnLine/onLine
                onLine: navigator.onLine,
                visibilityState: document.visibilityState
            }
        })(tr);
        return tr;
    };
};



var $4XhNP = parcelRequire("4XhNP");


var $dh538 = parcelRequire("dh538");




// Ignored via go/ees005
// eslint-disable-next-line import/no-namespace
var $d8b8a0a9e78d2357$exports = {};
$parcel$export($d8b8a0a9e78d2357$exports, "InsertTypeAheadStages", () => (parcelRequire("lTlMO")).InsertTypeAheadStages);
$parcel$export($d8b8a0a9e78d2357$exports, "InsertTypeAheadStep", () => (parcelRequire("lTlMO")).InsertTypeAheadStep);
$parcel$export($d8b8a0a9e78d2357$exports, "SetAttrsStep", () => (parcelRequire("c3x1B")).SetAttrsStep);
$parcel$export($d8b8a0a9e78d2357$exports, "AnalyticsStep", () => (parcelRequire("4XhNP")).AnalyticsStep);
$parcel$export($d8b8a0a9e78d2357$exports, "LinkMetaStep", () => (parcelRequire("44jjU")).LinkMetaStep);
$parcel$export($d8b8a0a9e78d2357$exports, "OverrideDocumentStep", () => (parcelRequire("7IUDA")).OverrideDocumentStep);
$parcel$export($d8b8a0a9e78d2357$exports, "BatchAttrsStep", () => (parcelRequire("5Mo8C")).BatchAttrsStep);

var $lTlMO = parcelRequire("lTlMO");


var $c3x1B = parcelRequire("c3x1B");





var $44jjU = parcelRequire("44jjU");


var $7IUDA = parcelRequire("7IUDA");


var $5Mo8C = parcelRequire("5Mo8C");



var $dd06b25aa902468a$exports = {};
$parcel$export($dd06b25aa902468a$exports, "TableSortOrder", () => (parcelRequire("5rHEx")).SortOrder);
$parcel$export($dd06b25aa902468a$exports, "TableSortStep", () => (parcelRequire("cCTpf")).TableSortStep);
$parcel$export($dd06b25aa902468a$exports, "AddColumnStep", () => (parcelRequire("1rJN9")).AddColumnStep);
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $5rHEx = parcelRequire("5rHEx");


var $cCTpf = parcelRequire("cCTpf");


var $1rJN9 = parcelRequire("1rJN9");




var $ks2lK = parcelRequire("ks2lK");


var $2eY6H = parcelRequire("2eY6H");















var $h3X17 = parcelRequire("h3X17");


var $6tl2G = parcelRequire("6tl2G");


var $TfRUG = parcelRequire("TfRUG");








var $ftzrq = parcelRequire("ftzrq");


var $jyw2s = parcelRequire("jyw2s");




const $251f784cd31b0be3$export$cc7116c03c331d66 = (id, decorations)=>decorations.find().reduce((arr, deco)=>deco.spec.pointer.presenceId === id ? arr.concat(deco) : arr, []);
function $251f784cd31b0be3$var$style(options) {
    const color = options && options.color || 'black';
    return `border-right: 2px solid ${color}; margin-right: -2px; z-index: 1`;
}
function $251f784cd31b0be3$export$90c6ee000c44ff4a(str) {
    const participantColor = (0, $jyw2s.getParticipantColor)(str);
    return {
        index: participantColor.index,
        backgroundColor: participantColor.color.backgroundColor,
        textColor: participantColor.color.textColor
    };
}
const $251f784cd31b0be3$export$8f868fb36fe42fe8 = (from, to, sessionId, isSelection, initial, presenceId, fullName, isNudged)=>{
    const decorations = [];
    const avatarColor = $251f784cd31b0be3$export$90c6ee000c44ff4a(presenceId);
    const color = avatarColor.index.toString();
    if (isSelection) {
        const className = `telepointer color-${color} telepointer-selection`;
        decorations.push((0, $ftzrq.Decoration).inline(from, to, {
            class: className
        }, {
            pointer: {
                sessionId: sessionId,
                presenceId: presenceId
            }
        }));
    }
    const spaceJoinerBefore = document.createElement('span');
    spaceJoinerBefore.textContent = (0, $TfRUG.ZERO_WIDTH_JOINER);
    const spaceJoinerAfter = document.createElement('span');
    spaceJoinerAfter.textContent = (0, $TfRUG.ZERO_WIDTH_JOINER);
    const cursor = document.createElement('span');
    cursor.textContent = (0, $TfRUG.ZERO_WIDTH_JOINER);
    cursor.className = `telepointer color-${color} telepointer-selection-badge`;
    cursor.style.cssText = `${$251f784cd31b0be3$var$style({
        color: avatarColor.backgroundColor
    })};`;
    cursor.setAttribute('aria-label', `${fullName} cursor position`);
    cursor.setAttribute('role', 'button');
    cursor.setAttribute((0, $h3X17.TELEPOINTER_DATA_SESSION_ID_ATTR), sessionId);
    // If there is an ongoing expand animation, we'll keep the telepointer expanded
    // until the keyframe animation is complete. Please note that this will restart the anim timer
    // from 0 everytime it's re-added.
    if (isNudged) cursor.classList.add((0, $h3X17.TELEPOINTER_PULSE_DURING_TR_CLASS));
    const fullNameEl = document.createElement('span');
    fullNameEl.textContent = fullName;
    fullNameEl.className = 'telepointer-fullname';
    fullNameEl.style.backgroundColor = avatarColor.backgroundColor;
    fullNameEl.style.color = avatarColor.textColor;
    fullNameEl.setAttribute('aria-hidden', 'true');
    cursor.appendChild(fullNameEl);
    const initialEl = document.createElement('span');
    initialEl.textContent = initial;
    initialEl.className = 'telepointer-initial';
    initialEl.style.backgroundColor = avatarColor.backgroundColor;
    initialEl.style.color = avatarColor.textColor;
    initialEl.setAttribute('aria-hidden', 'true');
    cursor.appendChild(initialEl);
    return decorations.concat((0, $ftzrq.Decoration).widget(to, spaceJoinerAfter, {
        pointer: {
            sessionId: sessionId,
            presenceId: presenceId
        },
        key: `telepointer-${sessionId}-zero`
    })).concat((0, $ftzrq.Decoration).widget(to, cursor, {
        pointer: {
            sessionId: sessionId,
            presenceId: presenceId
        },
        key: `telepointer-${sessionId}`
    })).concat((0, $ftzrq.Decoration).widget(to, spaceJoinerBefore, {
        pointer: {
            sessionId: sessionId,
            presenceId: presenceId
        },
        key: `telepointer-${sessionId}-zero`
    }));
};
const $251f784cd31b0be3$export$fe10d6bdd551e45e = (doc, state, version, options, reserveCursor, editorAnalyticsAPI)=>{
    const { schema: schema, tr: tr } = state;
    const parsedDoc = (0, $6tl2G.processRawValueWithoutValidation)(schema, doc, editorAnalyticsAPI?.fireAnalyticsEvent);
    const hasContent = !!parsedDoc?.childCount;
    const content = parsedDoc?.content;
    if (hasContent) {
        tr.setMeta('addToHistory', false);
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        tr.replaceWith(0, state.doc.nodeSize - 2, content);
        const selection = state.selection;
        if (reserveCursor) // If the cursor is still in the range of the new document,
        // keep where it was.
        {
            if (selection.to < tr.doc.content.size - 2) {
                const $from = tr.doc.resolve(selection.from);
                const $to = tr.doc.resolve(selection.to);
                const newselection = new (0, $ks2lK.TextSelection)($from, $to);
                tr.setSelection(newselection);
            }
        } else tr.setSelection((0, $ks2lK.Selection).atStart(tr.doc));
        tr.setMeta('replaceDocument', true);
        if (options && options.useNativePlugin) {
            const collabState = {
                version: version,
                unconfirmed: []
            };
            tr.setMeta('collab$', collabState);
        }
    }
    return tr;
};
const $251f784cd31b0be3$export$82e6f13680c85057 = (editorView, participants, sessionId, index, editorAnalyticsAPI)=>{
    const selectedUser = participants[index];
    if (selectedUser && selectedUser.cursorPos !== undefined && selectedUser.sessionId !== sessionId) {
        const { state: state } = editorView;
        const tr = state.tr;
        const analyticsPayload = {
            action: (0, $d925B.ACTION).MATCHED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).SELECTION,
            eventType: (0, $d925B.EVENT_TYPE).TRACK
        };
        tr.setSelection((0, $ks2lK.Selection).near(tr.doc.resolve(selectedUser.cursorPos)));
        editorAnalyticsAPI?.attachAnalyticsEvent(analyticsPayload)(tr);
        tr.scrollIntoView();
        editorView.dispatch(tr);
        if (!editorView.hasFocus()) editorView.focus();
    }
};
const $251f784cd31b0be3$export$4d66b240d6166074 = (sessionId, decorationSet)=>{
    let scrollPosition;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    decorationSet.find().forEach((deco)=>{
        if (deco.type.spec.pointer.sessionId === sessionId) scrollPosition = deco.from;
    });
    return scrollPosition;
};
const $251f784cd31b0be3$export$94600c572c12bcd6 = (step)=>step instanceof (0, $aXG5V.ReplaceStep);
const $251f784cd31b0be3$export$b8c92cc7dad49da = (transaction, metaTag)=>{
    const hasMetaTag = Boolean(transaction.getMeta(metaTag));
    if (hasMetaTag) return true;
    const appendedTransaction = transaction.getMeta('appendedTransaction');
    if (appendedTransaction instanceof (0, $ks2lK.Transaction)) return $251f784cd31b0be3$export$b8c92cc7dad49da(appendedTransaction, metaTag);
    return false;
};
/**
 * This list contains step attributes that do not result from a user action.
 * All steps that contain ONLY the blocked attribute are considered automated steps
 * and should not be recognised as organic change.
 *
 * `attr_colwidth` is an exception to above explanation. Resizing the column
 * currently creates too many steps and is therefore also on this list.
 *
 * Steps analycs dashboard: https://atlassian-discover.cloud.databricks.com/dashboardsv3/01ef4d3c8aa916c8b0cb5332a9f37caf/published?o=4482001201517624
 */ const $251f784cd31b0be3$var$blockedAttrsList = [
    '__contextId',
    'localId',
    '__autoSize',
    'attr_colwidth',
    'originalHeight',
    'originalWidth'
];
const $251f784cd31b0be3$export$227edb0398ff0ff6 = (tr)=>{
    // If document has not been marked as `docChanged` by PM, skip the rest of the logic
    if (!tr.docChanged) return false;
    return tr.steps.some((step)=>{
        // If a step is an instance of AnalyticsStep, it is not considered organic
        if (step instanceof (0, $4XhNP.AnalyticsStep)) return false;
        // editor-plugin-local-id uses AttrStep to set the localId attribute
        if (step instanceof (0, $aXG5V.AttrStep) && step.attr === 'localId') return false;
        // editor-plugin-local-id uses BatchAttrStep to set the localId attribute
        if (step instanceof (0, $5Mo8C.BatchAttrsStep) && (0, $dh538.fg)('platform_editor_inorganic_batchattrsstep_localid')) {
            const allAttributes = step.data.map((data)=>Object.keys(data.attrs)).flat();
            return allAttributes.some((attr)=>attr !== 'localId');
        }
        // If a step is not an instance of SetAttrsStep, it is considered organic
        if (!(step instanceof (0, $c3x1B.SetAttrsStep))) return true;
        const allAttributes = Object.keys(step.attrs);
        // If a step is an instance of SetAttrsStep, it checks if the attributes in the step
        // are not in the `blockedAttributes`. If one of the attributes not on the list, it considers the change
        // organic but only if the entire document is not equal to the previous state.
        return allAttributes.some((attr)=>{
            if (!$251f784cd31b0be3$var$blockedAttrsList.includes(attr)) return true;
        }) && !tr.doc.eq(tr.before);
    });
};
const $251f784cd31b0be3$export$6a7a563833bcd8 = (sessionId, nudgeAnimations)=>{
    const nudgeAnimStartTime = nudgeAnimations.get(sessionId);
    let hasExistingNudge = false;
    if (nudgeAnimStartTime) {
        const timeElapsed = Date.now() - nudgeAnimStartTime;
        hasExistingNudge = timeElapsed < (0, $h3X17.TELEPOINTER_PULSE_DURING_TR_DURATION_MS);
    }
    return hasExistingNudge;
};


const $5e2f0b1ed387432d$export$d970973925859b8e = ()=>{
    Object.entries($dd06b25aa902468a$exports).forEach(()=>{});
    Object.entries($d8b8a0a9e78d2357$exports).forEach(()=>{});
};
const $5e2f0b1ed387432d$export$a04a448cc866246 = (initData, view, options, editorAnalyticsApi)=>{
    const { doc: doc, json: json, version: version, reserveCursor: reserveCursor } = initData;
    if (doc) {
        const { state: state } = view;
        const tr = (0, $251f784cd31b0be3$export$fe10d6bdd551e45e)(doc, state, version, options, reserveCursor, editorAnalyticsApi);
        tr.setMeta('isRemote', true);
        view.dispatch(tr);
    } else if (json) $5e2f0b1ed387432d$export$ff4f2767b9e99aa9(json, view);
};
const $5e2f0b1ed387432d$export$cf9a0dcadb173615 = (connectionData, view)=>{
    const { state: { tr: tr } } = view;
    view.dispatch(tr.setMeta('sessionId', connectionData));
};
const $5e2f0b1ed387432d$export$f9db5387b510d6c = (presenceData, view)=>{
    const { state: { tr: tr } } = view;
    view.dispatch(tr.setMeta('presence', presenceData));
};
const $5e2f0b1ed387432d$export$c6643a6a2625d22c = (remoteData, view, options)=>{
    const { json: json, userIds: userIds = [] } = remoteData;
    if (json) $5e2f0b1ed387432d$export$ff4f2767b9e99aa9(json, view, userIds, options);
};
const $5e2f0b1ed387432d$export$ff4f2767b9e99aa9 = (// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
json, view, userIds, options)=>{
    if (!json || !json.length) return;
    const { state: state, state: { schema: schema } } = view;
    const steps = json.map((step)=>(0, $2eY6H.Step).fromJSON(schema, step));
    let tr;
    if (options && options.useNativePlugin && userIds) tr = (0, $9NwnH.receiveTransaction)(state, steps, userIds, {
        mapSelectionBackward: true
    });
    else {
        tr = state.tr;
        steps.forEach((step)=>tr.step(step));
    }
    if (tr) {
        tr.setMeta('addToHistory', false);
        tr.setMeta('isRemote', true);
        /*
		 * Persist marks across transactions. Fixes an issue where
		 * marks are lost if remote transactions are dispatched
		 * between a user creating the mark and typing.
		 */ if (state.tr.storedMarks) tr.setStoredMarks(state.tr.storedMarks);
        view.dispatch(tr);
    }
};
const $5e2f0b1ed387432d$export$abfa80d838a68fd6 = (telepointerData, view)=>{
    const { state: { tr: tr } } = view;
    view.dispatch(tr.setMeta('telepointer', telepointerData));
};
function $5e2f0b1ed387432d$var$isAllSelection(selection) {
    return selection instanceof (0, $ks2lK.AllSelection);
}
function $5e2f0b1ed387432d$var$isNodeSelection(selection) {
    return selection instanceof (0, $ks2lK.NodeSelection);
}
const $5e2f0b1ed387432d$export$b95b91cb8577b1db = (selection)=>{
    /**
	 * <kbd>CMD + A</kbd> triggers a AllSelection
	 * <kbd>escape</kbd> triggers a NodeSelection
	 */ return {
        type: 'textSelection',
        anchor: selection.anchor,
        head: $5e2f0b1ed387432d$var$isAllSelection(selection) || $5e2f0b1ed387432d$var$isNodeSelection(selection) ? selection.head - 1 : selection.head
    };
};





const $66421dcbcc8122ef$export$18d4026d1ea86bb1 = new (0, $ks2lK.PluginKey)('collabEditPlugin');


const $ea4f9fca74c39b80$export$8e0e7ffc78696d30 = ({ originalTransaction: originalTransaction, transactions: transactions, oldEditorState: oldEditorState, newEditorState: newEditorState, useNativePlugin: useNativePlugin, viewMode: viewMode, hideTelecursorOnLoad: hideTelecursorOnLoad })=>(provider)=>{
        const docChangedTransaction = transactions.find((tr)=>tr.docChanged);
        const currentPluginState = (0, $66421dcbcc8122ef$export$18d4026d1ea86bb1).getState(newEditorState);
        const trNoAnalytics = oldEditorState.tr;
        docChangedTransaction?.steps.forEach((step)=>{
            if (!(step instanceof (0, $4XhNP.AnalyticsStep))) trNoAnalytics.step(step);
        });
        if (!currentPluginState?.isReady) return;
        const newTransaction = (0, $iu6m9.editorExperiment)('platform_editor_reduce_noisy_steps_ncs', true, {
            exposure: true
        }) ? trNoAnalytics : docChangedTransaction;
        const shouldSendStepForSynchronyCollabProvider = !originalTransaction.getMeta('isRemote') && // TODO: ED-8995 - We need to do this check to reduce the number of race conditions when working with tables.
        // This metadata is coming from the scaleTable command in table-resizing plugin
        !originalTransaction.getMeta('scaleTable') && ((0, $iu6m9.editorExperiment)('platform_editor_reduce_noisy_steps_ncs', true) ? newTransaction?.docChanged : true);
        if (useNativePlugin || shouldSendStepForSynchronyCollabProvider) provider.send(newTransaction, oldEditorState, newEditorState);
        const prevPluginState = (0, $66421dcbcc8122ef$export$18d4026d1ea86bb1).getState(oldEditorState);
        const { activeParticipants: prevActiveParticipants } = prevPluginState || {};
        const { activeParticipants: activeParticipants, sessionId: sessionId } = currentPluginState;
        const selectionChanged = !oldEditorState.selection.eq(newEditorState.selection);
        const participantsChanged = prevActiveParticipants && !prevActiveParticipants.eq(activeParticipants);
        if ((0, $dh538.fg)('aifc_create_enabled')) {
            if (!sessionId || viewMode !== 'edit') return;
            // uiEvent is standard metdata (docs: https://prosemirror.net/docs/ref/#state.Transaction)
            const isPaste = docChangedTransaction?.getMeta('uiEvent') === 'paste';
            // If this metadata is truthy then it means a selection bookmark might be declared as the meta value OR the transaction
            // doesn't want the tr.selection to be sent to remote users at all.
            const remoteSelectionBookmark = originalTransaction.getMeta('useSelectionBookmarkForRemote');
            if (!!remoteSelectionBookmark) {
                if (remoteSelectionBookmark !== true && 'resolve' in remoteSelectionBookmark) {
                    const selection = remoteSelectionBookmark.resolve(newEditorState.doc);
                    const message = {
                        type: 'telepointer',
                        selection: (0, $5e2f0b1ed387432d$export$b95b91cb8577b1db)(selection),
                        sessionId: sessionId
                    };
                    provider.sendMessage(message);
                }
            } else if (// Broadcast the position if the selection has changed, and the doc hasn't changed (it is mapped
            // by the receiver).
            // If we're pasting content though make an exception (as doc has changed)
            // as on a ranged selection it results in not clearing the ranged selection after the paste
            selectionChanged && (!docChangedTransaction || isPaste) || participantsChanged && !hideTelecursorOnLoad) {
                const selection = (0, $5e2f0b1ed387432d$export$b95b91cb8577b1db)(newEditorState.selection);
                const message = {
                    type: 'telepointer',
                    selection: selection,
                    sessionId: sessionId
                };
                provider.sendMessage(message);
            }
        } else if (sessionId && viewMode === 'edit' && (selectionChanged && !docChangedTransaction || participantsChanged && !hideTelecursorOnLoad)) {
            const selection = (0, $5e2f0b1ed387432d$export$b95b91cb8577b1db)(newEditorState.selection);
            const message = {
                type: 'telepointer',
                selection: selection,
                sessionId: sessionId
            };
            provider.sendMessage(message);
        }
    };








function $b0d3b33c6517a237$export$75962d04b28eb982(steps) {
    const filteredSteps = steps.reduce((acc, rebaseable)=>{
        if (!(rebaseable.step instanceof (0, $4XhNP.AnalyticsStep))) acc.push(new (0, $9NwnH.Rebaseable)(rebaseable.step, rebaseable.inverted, rebaseable.origin));
        return acc;
    }, []);
    return filteredSteps;
}


// It is important to get all steps in that package
// Ignored via go/ees005
// eslint-disable-next-line import/no-namespace





var $ajtqX = parcelRequire("ajtqX");


var $1S4f7 = parcelRequire("1S4f7");






var $2XqLN = parcelRequire("2XqLN");













const $dff7c070b048fc1b$export$1fa2affd5117a057 = new (0, $ks2lK.PluginKey)('trackLastRemoteConflict');
const $dff7c070b048fc1b$export$ae829ec7b2625219 = ()=>{
    return new (0, $1S4f7.SafePlugin)({
        key: $dff7c070b048fc1b$export$1fa2affd5117a057,
        state: {
            init () {
                return undefined;
            },
            apply (transaction, prevPluginState) {
                const metadata = transaction.getMeta($dff7c070b048fc1b$export$1fa2affd5117a057);
                if (metadata) return metadata;
                return prevPluginState;
            }
        }
    });
};


// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $928a0df5510ee3ee$var$effect = (fn, eq)=>{
    let previousDeps;
    let cleanup;
    return (...currentDeps)=>{
        if (cleanup && eq(previousDeps, currentDeps)) return cleanup;
        cleanup = fn(...currentDeps);
        previousDeps = currentDeps;
        return cleanup;
    };
};
const $928a0df5510ee3ee$export$ec068583843480e7 = $928a0df5510ee3ee$var$effect((view, provider, options, featureFlags, _providerFactory, editorAnalyticsApi)=>{
    let entityRef;
    const entityHandlers = {
        disconnectedHandler: ()=>{
            (0, $469073082c3fe329$export$31cf0e3f119813a1)(view.state, view.state.tr)('disconnected', editorAnalyticsApi);
        },
        errorHandler: ()=>{
            (0, $469073082c3fe329$export$31cf0e3f119813a1)(view.state, view.state.tr)('error', editorAnalyticsApi);
        }
    };
    const unsubscribeSynchronyEntity = ()=>{
        if (entityRef) {
            entityRef.off('disconnected', entityHandlers.disconnectedHandler);
            entityRef.off('error', entityHandlers.errorHandler);
        }
    };
    const handlers = {
        initHandler: (data)=>{
            view.dispatch(view.state.tr.setMeta('collabInitialised', true));
            (0, $5e2f0b1ed387432d$export$a04a448cc866246)(data, view, options, editorAnalyticsApi);
        },
        connectedHandler: (data)=>(0, $5e2f0b1ed387432d$export$cf9a0dcadb173615)(data, view),
        dataHandler: (data)=>(0, $5e2f0b1ed387432d$export$c6643a6a2625d22c)(data, view, options),
        presenceHandler: (data)=>(0, $5e2f0b1ed387432d$export$f9db5387b510d6c)(data, view),
        telepointerHandler: (data)=>(0, $5e2f0b1ed387432d$export$abfa80d838a68fd6)(data, view),
        localStepsHandler: (data)=>{
            const { steps: steps } = data;
            const { state: state } = view;
            const { tr: tr } = state;
            steps.forEach((step)=>tr.step(step));
            view.dispatch(tr);
        },
        errorHandler: (error)=>{
            (0, $469073082c3fe329$export$8c408a1f4e12c948)(view.state, view.state.tr, featureFlags, editorAnalyticsApi)(error);
        },
        entityHandler: ({ entity: entity })=>{
            unsubscribeSynchronyEntity();
            if (options.EXPERIMENTAL_allowInternalErrorAnalytics) {
                entity.on('disconnected', entityHandlers.disconnectedHandler);
                entity.on('error', entityHandlers.errorHandler);
                entityRef = entity;
            }
        },
        dataConflictHandler: (data)=>{
            view.dispatch(view.state.tr.setMeta((0, $dff7c070b048fc1b$export$1fa2affd5117a057), data));
        }
    };
    provider.on('init', handlers.initHandler).on('connected', handlers.connectedHandler).on('data', handlers.dataHandler).on('presence', handlers.presenceHandler).on('telepointer', handlers.telepointerHandler).on('local-steps', handlers.localStepsHandler).on('error', handlers.errorHandler).on('entity', handlers.entityHandler).on('data:conflict', handlers.dataConflictHandler);
    return ()=>{
        unsubscribeSynchronyEntity();
        provider.off('init', handlers.initHandler).off('connected', handlers.connectedHandler).off('data', handlers.dataHandler).off('presence', handlers.presenceHandler).off('telepointer', handlers.telepointerHandler).off('local-steps', handlers.localStepsHandler).off('error', handlers.errorHandler).off('entity', handlers.entityHandler).off('data:conflict', handlers.dataConflictHandler);
    };
}, (previousDeps, currentDeps)=>currentDeps && currentDeps.every((dep, i)=>dep === previousDeps[i]));


const $a7cf3e66d2d5bf31$var$initCollab = (collabEditProvider, view)=>{
    if (collabEditProvider.initialize) collabEditProvider.initialize(()=>view.state, (json)=>(0, $2eY6H.Step).fromJSON(view.state.schema, json));
};
const $a7cf3e66d2d5bf31$var$initNewCollab = (collabEditProvider, view, editorApi, onSyncUpError)=>{
    collabEditProvider.setup({
        getState: ()=>view.state,
        editorApi: editorApi,
        onSyncUpError: onSyncUpError
    });
};
const $a7cf3e66d2d5bf31$var$initCollabMemo = (0, $2XqLN.default)($a7cf3e66d2d5bf31$var$initCollab);
const $a7cf3e66d2d5bf31$export$2a47f398eeff8b01 = ({ options: options, providerFactory: providerFactory, view: view, featureFlags: featureFlags, editorAnalyticsApi: editorAnalyticsApi, pluginInjectionApi: pluginInjectionApi })=>(provider)=>{
        // eslint-disable-next-line prefer-const
        let cleanup;
        const pluginState = (0, $66421dcbcc8122ef$export$18d4026d1ea86bb1).getState(view.state);
        if (pluginState?.isReady && cleanup) cleanup();
        cleanup = (0, $928a0df5510ee3ee$export$ec068583843480e7)(view, provider, options, featureFlags, providerFactory, editorAnalyticsApi);
        // Initialize provider
        if (options.useNativePlugin) // ED-13912 For NCS we don't want to use memoizeOne because it causes
        // infinite text while changing page-width
        $a7cf3e66d2d5bf31$var$initNewCollab(provider, view, pluginInjectionApi, options.onSyncUpError);
        else /**
			 * We only want to initialise once, if we reload/reconfigure this plugin
			 * We dont want to re-init collab, it would break existing sessions
			 */ $a7cf3e66d2d5bf31$var$initCollabMemo(provider, view);
        return cleanup;
    };




var $d7ZU3 = parcelRequire("d7ZU3");
















class $4ac32b234017c082$export$3ebbcd8e174d58e4 {
    add(data) {
        const newSet = new Map(this.participants);
        data.forEach((participant)=>{
            newSet.set(participant.sessionId, participant);
        });
        return new $4ac32b234017c082$export$3ebbcd8e174d58e4(newSet);
    }
    remove(sessionIds) {
        const newSet = new Map(this.participants);
        sessionIds.forEach((sessionId)=>{
            newSet.delete(sessionId);
        });
        return new $4ac32b234017c082$export$3ebbcd8e174d58e4(newSet);
    }
    update(sessionId, lastActive) {
        const newSet = new Map(this.participants);
        const data = newSet.get(sessionId);
        if (!data) return this;
        newSet.set(sessionId, {
            ...data,
            lastActive: lastActive
        });
        return new $4ac32b234017c082$export$3ebbcd8e174d58e4(newSet);
    }
    updateCursorPos(sessionId, cursorPos) {
        const newSet = new Map(this.participants);
        const data = newSet.get(sessionId);
        if (!data) return this;
        newSet.set(sessionId, {
            ...data,
            cursorPos: cursorPos
        });
        return new $4ac32b234017c082$export$3ebbcd8e174d58e4(newSet);
    }
    toArray() {
        return Array.from(this.participants.values());
    }
    get(sessionId) {
        return this.participants.get(sessionId);
    }
    size() {
        return this.participants.size;
    }
    eq(other) {
        const left = this.toArray().map((p)=>p.sessionId).sort((a, b)=>a > b ? -1 : 1).join('');
        const right = other.toArray().map((p)=>p.sessionId).sort((a, b)=>a > b ? -1 : 1).join('');
        return left === right;
    }
    constructor(participants = new Map()){
        this.participants = void 0;
        this.participants = participants;
    }
}



const $c84f494477793052$export$1e860daa85a829a5 = (tr, pos)=>{
    const endOfDocPos = tr.doc.nodeSize - 2;
    if (pos <= endOfDocPos) {
        const resolvedPos = tr.doc.resolve(pos);
        const backwardSelection = (0, $ks2lK.Selection).findFrom(resolvedPos, -1, true);
        // if there's no correct cursor position before the `pos`, we try to find it after the `pos`
        const forwardSelection = (0, $ks2lK.Selection).findFrom(resolvedPos, 1, true);
        return backwardSelection ? backwardSelection.from : forwardSelection ? forwardSelection.from : pos;
    }
    return endOfDocPos;
};
class $c84f494477793052$export$d8e4bc17e84598c5 {
    get decorations() {
        return this.decorationSet;
    }
    get activeParticipants() {
        return this.participants;
    }
    get sessionId() {
        return this.sid;
    }
    getFullName(sessionId) {
        const participant = this.participants.get(sessionId);
        return participant ? participant.name : 'X';
    }
    getInitial(sessionId) {
        return this.getFullName(sessionId).substring(0, 1).toUpperCase();
    }
    getPresenceId(sessionId) {
        const participant = this.participants.get(sessionId);
        return participant?.presenceId ?? sessionId;
    }
    apply(tr) {
        // Ignored via go/ees005
        // eslint-disable-next-line prefer-const
        let { participants: participants, sid: sid, isReady: isReady } = this;
        const presenceData = tr.getMeta('presence');
        const telepointerData = tr.getMeta('telepointer');
        const nudgeTelepointerData = tr.getMeta('nudgeTelepointer');
        const sessionIdData = tr.getMeta('sessionId');
        let collabInitialised = tr.getMeta('collabInitialised');
        if (typeof collabInitialised !== 'boolean') collabInitialised = isReady;
        if (sessionIdData) sid = sessionIdData.sid;
        let add = [];
        let remove = [];
        if (presenceData) {
            const { joined: joined = [], left: left = [] } = presenceData;
            participants = participants.remove(left.map((i)=>i.sessionId));
            participants = participants.add(joined);
            // Remove telepointers for users that left
            left.forEach((i)=>{
                const pointers = (0, $251f784cd31b0be3$export$cc7116c03c331d66)(this.getPresenceId(i.sessionId), this.decorationSet);
                if (pointers) remove = remove.concat(pointers);
            });
        }
        if (telepointerData) {
            const { sessionId: sessionId } = telepointerData;
            if (participants.get(sessionId) && sessionId !== sid) {
                const oldPointers = (0, $251f784cd31b0be3$export$cc7116c03c331d66)(this.getPresenceId(sessionId), this.decorationSet);
                if (oldPointers) remove = remove.concat(oldPointers);
                const endOfDocPos = tr.doc.nodeSize - 2;
                const anchor = telepointerData.selection.anchor;
                const head = telepointerData.selection.head;
                let rawFrom = anchor < head ? anchor : head;
                let rawTo = anchor >= head ? anchor : head;
                if (rawFrom > endOfDocPos) rawFrom = endOfDocPos;
                if (rawTo > endOfDocPos) rawTo = endOfDocPos;
                const isSelection = rawTo - rawFrom > 0;
                let from = 1;
                let to = 1;
                try {
                    from = $c84f494477793052$export$1e860daa85a829a5(tr, isSelection ? Math.max(rawFrom, 0) : rawFrom);
                    to = isSelection ? $c84f494477793052$export$1e860daa85a829a5(tr, rawTo) : from;
                } catch (err) {
                    this.onError(err);
                }
                add = add.concat((0, $251f784cd31b0be3$export$8f868fb36fe42fe8)(from, to, sessionId, isSelection, this.getInitial(sessionId), this.getPresenceId(sessionId), this.getFullName(sessionId), (0, $251f784cd31b0be3$export$6a7a563833bcd8)(sessionId, this.nudgeAnimations)));
            }
        }
        if (tr.docChanged) {
            // Adjust decoration positions to changes made by the transaction
            try {
                this.decorationSet = this.decorationSet.map(tr.mapping, tr.doc, {
                    // Reapplies decorators those got removed by the state change
                    onRemove: (spec)=>{
                        if (spec.pointer && spec.pointer.sessionId && spec.key === `telepointer-${spec.pointer.sessionId}`) {
                            const step = tr.steps.filter((0, $251f784cd31b0be3$export$94600c572c12bcd6))[0];
                            if (step) {
                                const { sessionId: sessionId, presenceId: presenceId } = spec.pointer;
                                const { slice: { content: { size: size } }, from: from } = step;
                                const pos = $c84f494477793052$export$1e860daa85a829a5(tr, size ? Math.min(from + size, tr.doc.nodeSize - 3) : Math.max(from, 1));
                                add = add.concat((0, $251f784cd31b0be3$export$8f868fb36fe42fe8)(pos, pos, sessionId, false, this.getInitial(sessionId), presenceId, this.getFullName(sessionId), (0, $251f784cd31b0be3$export$6a7a563833bcd8)(sessionId, this.nudgeAnimations)));
                            }
                        }
                    }
                });
            } catch (err) {
                this.onError(err);
            }
            if (!(0, $dh538.fg)('aifc_create_enabled')) // Remove any selection decoration within the change range,
            // takes care of the issue when after pasting we end up with a dead selection
            tr.steps.filter((0, $251f784cd31b0be3$export$94600c572c12bcd6)).forEach((s)=>{
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const { from: from, to: to } = s;
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                this.decorationSet.find(from, to).forEach((deco)=>{
                    // `type` is private, `from` and `to` are public in latest version
                    // `from` != `to` means it's a selection
                    if (deco.from !== deco.to) remove.push(deco);
                });
            });
        }
        const { selection: selection } = tr;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.decorationSet.find().forEach((deco)=>{
            if (deco.type.toDOM) {
                const hasTelepointerDimClass = deco.type.toDOM.classList.contains((0, $h3X17.TELEPOINTER_DIM_CLASS));
                const browser = (0, $1oCLl.expValEquals)('platform_editor_hydratable_ui', 'isEnabled', true) ? (0, $d7ZU3.getBrowserInfo)() : (0, $d7ZU3.browser);
                if (deco.from === selection.from && deco.to === selection.to) {
                    if (!hasTelepointerDimClass) deco.type.toDOM.classList.add((0, $h3X17.TELEPOINTER_DIM_CLASS));
                    // Browser condition here to fix ED-14722 where telepointer
                    // decorations with side -1 in Firefox causes backspace issues.
                    // This is likely caused by contenteditable quirks in Firefox
                    if (!browser.gecko) deco.type.side = -1;
                } else {
                    if (hasTelepointerDimClass) deco.type.toDOM.classList.remove((0, $h3X17.TELEPOINTER_DIM_CLASS));
                    deco.type.side = 0;
                }
            }
        });
        if (nudgeTelepointerData) {
            const nudgeSessionId = nudgeTelepointerData?.sessionId;
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            this.decorationSet.find().forEach((deco)=>{
                if (deco.type.toDOM && participants.get(nudgeSessionId) && deco.spec?.pointer?.sessionId === nudgeSessionId && deco.spec?.key === `telepointer-${nudgeSessionId}`) {
                    // Restart animation by removing and re-adding the class
                    deco.type.toDOM.classList.remove((0, $h3X17.TELEPOINTER_PULSE_DURING_TR_CLASS));
                    deco.type.toDOM.classList.remove((0, $h3X17.TELEPOINTER_PULSE_CLASS));
                    deco.type.toDOM.offsetWidth; // Force reflow
                    deco.type.toDOM.classList.add((0, $h3X17.TELEPOINTER_PULSE_CLASS));
                    this.nudgeAnimations.set(nudgeSessionId, Date.now());
                }
            });
        }
        if (remove.length) this.decorationSet = this.decorationSet.remove(remove);
        if (add.length) this.decorationSet = this.decorationSet.add(tr.doc, add);
        // This piece needs to be after the decorationSet adjustments,
        // otherwise it's always one step behind where the cursor is
        if (telepointerData) {
            const { sessionId: sessionId } = telepointerData;
            if (participants.get(sessionId)) {
                const positionForScroll = (0, $251f784cd31b0be3$export$4d66b240d6166074)(sessionId, this.decorationSet);
                if (positionForScroll) participants = participants.updateCursorPos(sessionId, positionForScroll);
            }
        }
        const nextState = new $c84f494477793052$export$d8e4bc17e84598c5(this.decorationSet, participants, sid, collabInitialised, this.onError, this.nudgeAnimations);
        return $c84f494477793052$export$d8e4bc17e84598c5.eq(nextState, this) ? this : nextState;
    }
    static eq(a, b) {
        return a.participants === b.participants && a.sessionId === b.sessionId && a.isReady === b.isReady;
    }
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    static init(config) {
        const { doc: doc, onError: onError } = config;
        return new $c84f494477793052$export$d8e4bc17e84598c5((0, $ftzrq.DecorationSet).create(doc, []), new (0, $4ac32b234017c082$export$3ebbcd8e174d58e4)(), undefined, undefined, onError);
    }
    constructor(decorations, participants, sessionId, collabInitalised = false, onError, nudgeAnimations = new Map()){
        this.decorationSet = void 0;
        this.participants = void 0;
        this.nudgeAnimations = void 0;
        // eslint-disable-next-line no-console
        this.onError = (error)=>console.error(error);
        this.sid = void 0;
        this.isReady = void 0;
        this.decorationSet = decorations;
        this.participants = participants;
        this.sid = sessionId;
        this.isReady = collabInitalised;
        this.onError = onError || this.onError;
        this.nudgeAnimations = nudgeAnimations;
    }
}


const $cca91a3622c8da39$var$enforceCustomStepRegisters = ()=>{
    const tryToRegisterStep = (obj)=>{
        for (const customStep of Object.values(obj)){
            // I know this seems awful
            // But unfortunate ProseMirror does not expose the jsonID property p
            // @ts-expect-error
            const id = customStep?.prototype?.jsonID;
            if (typeof id === 'string') try {
                // We are trying to re-register the steps here
                // in the normal flow, those custom step should be already registred
                // So, it should throw an expeception
                // @ts-expect-error
                (0, $2eY6H.Step).jsonID(id, customStep);
            } catch (e) {
            // This mean the step was already registred.
            // It is ok to ignore this exception.
            }
        }
    };
    // @ts-expect-error
    tryToRegisterStep($dd06b25aa902468a$exports);
    // @ts-expect-error
    tryToRegisterStep($d8b8a0a9e78d2357$exports);
};
const $cca91a3622c8da39$export$ae829ec7b2625219 = (dispatch, providerFactory, providerResolver, collabProviderCallback, options, featureFlags, pluginInjectionApi)=>{
    $cca91a3622c8da39$var$enforceCustomStepRegisters();
    return new (0, $1S4f7.SafePlugin)({
        key: (0, $66421dcbcc8122ef$export$18d4026d1ea86bb1),
        state: {
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            init (config) {
                return (0, $c84f494477793052$export$d8e4bc17e84598c5).init(config);
            },
            apply (transaction, prevPluginState, _oldEditorState, _newEditorState) {
                const pluginState = prevPluginState.apply(transaction);
                dispatch((0, $66421dcbcc8122ef$export$18d4026d1ea86bb1), pluginState);
                return pluginState;
            }
        },
        props: {
            decorations (state) {
                return (0, $66421dcbcc8122ef$export$18d4026d1ea86bb1).getState(state)?.decorations;
            },
            handleDOMEvents: {
                click (view, event) {
                    if (!(event.target instanceof HTMLElement)) return false;
                    if (!view.state.selection.empty) return false;
                    const { pos: pos } = view.state.tr.selection.$from;
                    if (!pos) return false;
                    // check if the pos is the same pos as a telepointer decoration
                    const decorations = (0, $66421dcbcc8122ef$export$18d4026d1ea86bb1).getState(view.state)?.decorations?.find(pos, pos);
                    if (!decorations?.length) return false;
                    // analytics to track telepointer clicks as they sometimes cause broken selections
                    const fireAnalyticsCallback = (0, $ajtqX.fireAnalyticsEvent)(pluginInjectionApi?.analytics?.sharedState.currentState()?.createAnalyticsEvent ?? undefined);
                    fireAnalyticsCallback({
                        payload: {
                            action: (0, $d925B.ACTION).CLICKED,
                            actionSubject: (0, $d925B.ACTION_SUBJECT).TELEPOINTER,
                            actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).TELEPOINTER,
                            eventType: (0, $d925B.EVENT_TYPE).TRACK
                        }
                    });
                }
            }
        },
        filterTransaction (tr, state) {
            const pluginState = (0, $66421dcbcc8122ef$export$18d4026d1ea86bb1).getState(state);
            const collabInitialiseTr = tr.getMeta('collabInitialised');
            // Don't allow transactions that modifies the document before
            // collab-plugin is ready.
            if (collabInitialiseTr) return true;
            if (!pluginState?.isReady && tr.docChanged) return false;
            return true;
        },
        view (view) {
            const addErrorAnalytics = (0, $469073082c3fe329$export$8c408a1f4e12c948)(view.state, view.state.tr, featureFlags, pluginInjectionApi?.analytics?.actions);
            const onSyncUpError = (attributes)=>{
                const fireAnalyticsCallback = (0, $ajtqX.fireAnalyticsEvent)(pluginInjectionApi?.analytics?.sharedState.currentState()?.createAnalyticsEvent ?? undefined);
                fireAnalyticsCallback({
                    payload: {
                        action: (0, $d925B.ACTION).NEW_COLLAB_SYNC_UP_ERROR_NO_STEPS,
                        actionSubject: (0, $d925B.ACTION_SUBJECT).EDITOR,
                        eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
                        attributes: attributes
                    }
                });
            };
            options.onSyncUpError = onSyncUpError;
            const cleanup = collabProviderCallback((0, $a7cf3e66d2d5bf31$export$2a47f398eeff8b01)({
                view: view,
                options: options,
                providerFactory: providerFactory,
                featureFlags: featureFlags,
                pluginInjectionApi: pluginInjectionApi,
                editorAnalyticsApi: pluginInjectionApi?.analytics?.actions
            }), addErrorAnalytics);
            providerFactory && providerFactory.subscribe('collabEditProvider', (_name, providerPromise)=>{
                if (providerPromise) providerPromise.then((provider)=>providerResolver(provider));
            });
            return {
                destroy () {
                    providerFactory.unsubscribeAll('collabEditProvider');
                    if (cleanup) cleanup.then((unsubscribe)=>{
                        if (unsubscribe) unsubscribe();
                    });
                }
            };
        }
    });
};












const $535e7c47bdfe9cbe$var$isLocked = (step)=>{
    if (step.origin instanceof (0, $ks2lK.Transaction)) return step.origin.getMeta('mergeIsLocked');
    return false;
};
function $535e7c47bdfe9cbe$export$8e3092acded15d5d(steps, api) {
    const mergedSteps = steps.reduce((acc, rebaseable)=>{
        const lastStep = acc[acc.length - 1];
        const isOffline = api?.connectivity?.sharedState.currentState()?.mode === 'offline';
        const isOnlineMergeEnabled = (0, $1oCLl.expValEquals)('platform_editor_enable_single_player_step_merging', 'isEnabled', true);
        const isMergingEnabled = isOffline || isOnlineMergeEnabled;
        if (isMergingEnabled && lastStep && !$535e7c47bdfe9cbe$var$isLocked(lastStep) && !$535e7c47bdfe9cbe$var$isLocked(rebaseable)) {
            const mergedStep = lastStep.step.merge(rebaseable.step);
            const inverted = rebaseable.inverted.merge(lastStep.inverted);
            // Always take the origin of the new step.
            // We use this in packages/editor/collab-provider/src/document/document-service.ts:commitUnconfirmedSteps
            // to confirm that the last transaction has been sent. Since we're taking the latest this still works as expected
            // As we want to wait until all the transactions have been pushed through
            const origin = lastStep.origin;
            if (mergedStep && inverted) {
                acc[acc.length - 1] = new (0, $9NwnH.Rebaseable)(mergedStep, inverted, origin instanceof (0, $ks2lK.Transaction) ? origin.setMeta('isOffline', origin.getMeta('isOffline') === true || isOffline) : origin);
                return acc;
            }
        }
        acc.push(new (0, $9NwnH.Rebaseable)(rebaseable.step, rebaseable.inverted, rebaseable.origin instanceof (0, $ks2lK.Transaction) ? rebaseable.origin.setMeta('isOffline', rebaseable.origin.getMeta('isOffline') === true || isOffline) : rebaseable.origin));
        return acc;
    }, []);
    return mergedSteps;
}








const $7ad60ed4c4777fb2$var$nativeCollabProviderPluginKey = new (0, $ks2lK.PluginKey)('nativeCollabProviderPlugin');
const $7ad60ed4c4777fb2$export$ad653665b59b3ffd = ({ providerPromise: providerPromise })=>{
    return new (0, $1S4f7.SafePlugin)({
        key: $7ad60ed4c4777fb2$var$nativeCollabProviderPluginKey,
        state: {
            init: ()=>null,
            apply: (tr, currentPluginState)=>{
                const provider = tr.getMeta($7ad60ed4c4777fb2$var$nativeCollabProviderPluginKey);
                return provider ? provider : currentPluginState;
            }
        },
        view: (editorView)=>{
            providerPromise.then((provider)=>{
                const { dispatch: dispatch, state: state } = editorView;
                const tr = state.tr;
                tr.setMeta($7ad60ed4c4777fb2$var$nativeCollabProviderPluginKey, provider);
                dispatch(tr);
            });
            return {};
        }
    });
};
const $7ad60ed4c4777fb2$export$82feb779db31f396 = (editorState)=>{
    return $7ad60ed4c4777fb2$var$nativeCollabProviderPluginKey.getState(editorState);
};




















const $e93f8b61e819792a$var$THRESHOLD = 50; // 50 milliseconds
const $e93f8b61e819792a$export$2d791416d1075a3b = (step)=>{
    const serializedStep = step.toJSON();
    const sanitizedStep = {
        stepType: serializedStep.stepType,
        stepInstance: 'unknown'
    };
    if (step instanceof (0, $aXG5V.AttrStep)) {
        sanitizedStep.attr = step.attr;
        sanitizedStep.stepInstance = 'AttrStep';
    } else if (step instanceof (0, $aXG5V.DocAttrStep)) {
        sanitizedStep.attr = step.attr;
        sanitizedStep.stepInstance = 'DocAttrStep';
    } else if (step instanceof (0, $c3x1B.SetAttrsStep)) {
        // Combines all attrs keys separated by _ to one single string
        sanitizedStep.attr = Object.keys(step.attrs).sort().join('_');
        sanitizedStep.stepInstance = 'SetAttrsStep';
    } else if (step instanceof (0, $aXG5V.AddMarkStep)) {
        sanitizedStep.markType = step.mark.type.name;
        sanitizedStep.stepInstance = 'AddMarkStep';
    } else if (step instanceof (0, $aXG5V.RemoveMarkStep)) {
        sanitizedStep.markType = step.mark.type.name;
        sanitizedStep.stepInstance = 'RemoveMarkStep';
    } else if (step instanceof (0, $aXG5V.RemoveNodeMarkStep)) {
        sanitizedStep.markType = step.mark.type.name;
        sanitizedStep.stepInstance = 'RemoveNodeMarkStep';
    } else if (step instanceof (0, $aXG5V.AddNodeMarkStep)) {
        sanitizedStep.markType = step.mark.type.name;
        sanitizedStep.stepInstance = 'AddNodeMarkStep';
    } else if (step instanceof (0, $aXG5V.ReplaceStep)) sanitizedStep.stepInstance = 'ReplaceStep';
    else if (step instanceof (0, $aXG5V.ReplaceAroundStep)) sanitizedStep.stepInstance = 'ReplaceAroundStep';
    else if (step instanceof (0, $4XhNP.AnalyticsStep)) sanitizedStep.stepInstance = 'AnalyticsStep';
    else if (step instanceof (0, $lTlMO.InsertTypeAheadStep)) sanitizedStep.stepInstance = 'InsertTypeAheadStep';
    else if (step instanceof (0, $44jjU.LinkMetaStep)) sanitizedStep.stepInstance = 'LinkMetaStep';
    return sanitizedStep;
};
const $e93f8b61e819792a$export$4bff6ad17bbfeba7 = (recentTransactionsTimestamps, trackFilteredTransaction)=>{
    return (tr)=>{
        if (Boolean(tr.getMeta('appendTransaction'))) return true;
        const isRemote = Boolean(tr.getMeta('isRemote'));
        if (isRemote) return true;
        const containsExcludedSteps = tr.steps.some((step)=>{
            return step instanceof (0, $4XhNP.AnalyticsStep) || step instanceof (0, $aXG5V.ReplaceStep) || step instanceof (0, $aXG5V.ReplaceAroundStep) || step instanceof (0, $44jjU.LinkMetaStep);
        });
        if (containsExcludedSteps) return true;
        if (tr.docChanged && tr.doc.eq(tr.before)) {
            const transactionKey = $e93f8b61e819792a$export$16b712be60324104(tr);
            if (!transactionKey) return true;
            //Clean up tracked transactions when time over threshold
            recentTransactionsTimestamps.forEach((value, key)=>{
                if (tr.time - value.timestamp > $e93f8b61e819792a$var$THRESHOLD) // Delete tracked transaction when over threshold
                recentTransactionsTimestamps.delete(key);
            });
            const lastTransactionEntry = recentTransactionsTimestamps.get(transactionKey);
            if (!lastTransactionEntry) {
                // If no timestamp exists for the given transaction, allow transaction and add an entry
                recentTransactionsTimestamps.set(transactionKey, {
                    timestamp: tr.time,
                    steps: tr.steps
                });
                return true;
            }
            // Track analytics for the filtered transaction
            trackFilteredTransaction(tr);
            // Filter transaction
            return false;
        }
        return true; // Allow the transaction
    };
};
function $e93f8b61e819792a$export$16b712be60324104(tr) {
    const stepPositions = tr.steps.map((step)=>{
        if (step instanceof (0, $aXG5V.RemoveNodeMarkStep) || step instanceof (0, $aXG5V.AddNodeMarkStep) || step instanceof (0, $c3x1B.SetAttrsStep) || step instanceof (0, $aXG5V.AttrStep)) {
            if (step.pos !== undefined) return `${step.pos}`;
        } else if (step instanceof (0, $aXG5V.AddMarkStep) || step instanceof (0, $aXG5V.RemoveMarkStep)) return `from_${step.from}_to_${step.to}`;
        else if (step instanceof (0, $lTlMO.InsertTypeAheadStep)) return `insertTypeAheadStep`;
        return '';
    });
    if (stepPositions.some((step)=>Boolean(step))) return stepPositions.join('_');
    return '';
}
const $e93f8b61e819792a$export$ea2d2436326e1247 = new (0, $ks2lK.PluginKey)('trackAndFilterSpammingStepsPluginKey');
const $e93f8b61e819792a$export$ae829ec7b2625219 = (trackFilteredTransaction)=>{
    const recentTransactionsTimestamps = new Map();
    return new (0, $1S4f7.SafePlugin)({
        key: $e93f8b61e819792a$export$ea2d2436326e1247,
        filterTransaction: $e93f8b61e819792a$export$4bff6ad17bbfeba7(recentTransactionsTimestamps, trackFilteredTransaction)
    });
};















const $c97c8d128269dcfd$export$e968e014d3efd8b6 = new (0, $ks2lK.PluginKey)('collabTrackLastOrganicChangePlugin');
const $c97c8d128269dcfd$export$ae829ec7b2625219 = ()=>{
    return new (0, $1S4f7.SafePlugin)({
        key: $c97c8d128269dcfd$export$e968e014d3efd8b6,
        state: {
            init () {
                return {
                    lastLocalOrganicChangeAt: null,
                    lastRemoteOrganicChangeAt: null,
                    lastLocalOrganicBodyChangeAt: null,
                    lastRemoteOrganicBodyChangeAt: null
                };
            },
            apply (transaction, prevPluginState) {
                if (Boolean(transaction.getMeta('appendedTransaction'))) return prevPluginState;
                const isRemote = Boolean(transaction.getMeta('isRemote'));
                const isDocumentReplaceFromRemote = isRemote && Boolean(transaction.getMeta('replaceDocument'));
                // Inline comment annotations are not considered as edits to the document body
                const isAnnotationStep = !!transaction.steps.find((step)=>(step instanceof (0, $aXG5V.AddMarkStep) || step instanceof (0, $aXG5V.RemoveMarkStep)) && step.mark?.type?.name === 'annotation');
                if (isDocumentReplaceFromRemote) return prevPluginState;
                if ((0, $h3X17.isDirtyTransaction)(transaction)) return prevPluginState;
                if ((0, $251f784cd31b0be3$export$227edb0398ff0ff6)(transaction)) {
                    if (isRemote) return {
                        lastLocalOrganicChangeAt: prevPluginState.lastLocalOrganicChangeAt,
                        lastRemoteOrganicChangeAt: Date.now(),
                        lastLocalOrganicBodyChangeAt: prevPluginState.lastLocalOrganicBodyChangeAt,
                        lastRemoteOrganicBodyChangeAt: isAnnotationStep ? prevPluginState.lastRemoteOrganicBodyChangeAt : Date.now()
                    };
                    return {
                        lastLocalOrganicChangeAt: Date.now(),
                        lastRemoteOrganicChangeAt: prevPluginState.lastRemoteOrganicChangeAt,
                        lastLocalOrganicBodyChangeAt: isAnnotationStep ? prevPluginState.lastLocalOrganicBodyChangeAt : Date.now(),
                        lastRemoteOrganicBodyChangeAt: prevPluginState.lastRemoteOrganicBodyChangeAt
                    };
                }
                return prevPluginState;
            }
        }
    });
};















const $1bf8747c56e383f6$export$a79cdfb4b852386b = new (0, $ks2lK.PluginKey)('collabTrackNCSInitializationPlugin');
const $1bf8747c56e383f6$export$ae829ec7b2625219 = ()=>{
    return new (0, $1S4f7.SafePlugin)({
        key: $1bf8747c56e383f6$export$a79cdfb4b852386b,
        state: {
            init () {
                return {
                    collabInitialisedAt: null,
                    firstChangeAfterInitAt: null,
                    firstContentBodyChangeAfterInitAt: null
                };
            },
            apply (transaction, prevPluginState, oldState) {
                if (Boolean(transaction.getMeta('collabInitialised'))) return {
                    collabInitialisedAt: Date.now(),
                    firstChangeAfterInitAt: null,
                    firstContentBodyChangeAfterInitAt: null
                };
                const shouldCheckDocument = prevPluginState.collabInitialisedAt && !prevPluginState.firstContentBodyChangeAfterInitAt;
                if (!shouldCheckDocument) return prevPluginState;
                const isRemote = (0, $251f784cd31b0be3$export$b8c92cc7dad49da)(transaction, 'isRemote');
                const isDocumentReplaceFromRemote = isRemote && (0, $251f784cd31b0be3$export$b8c92cc7dad49da)(transaction, 'replaceDocument');
                if (isDocumentReplaceFromRemote) return prevPluginState;
                if ((0, $h3X17.isDirtyTransaction)(transaction)) return prevPluginState;
                if (transaction.docChanged && !transaction.doc.eq(oldState.doc)) {
                    // For analytics purposes, inline comment annotations are not considered as edits to the document body
                    // Transaction may contain other steps, but we know that they won't be user-generated (non synthetic) steps
                    // Additionally, for analytics purposes we do not want to trigger on other participants' changes (i.e. remote changes)
                    const isAnnotationStep = !!transaction.steps.find((step)=>step instanceof (0, $aXG5V.AddMarkStep) && step.mark?.type?.name === 'annotation');
                    return {
                        collabInitialisedAt: prevPluginState.collabInitialisedAt,
                        firstChangeAfterInitAt: Date.now(),
                        firstContentBodyChangeAfterInitAt: isAnnotationStep || isRemote ? prevPluginState.firstContentBodyChangeAfterInitAt : Date.now()
                    };
                }
                return prevPluginState;
            }
        },
        props: {
            attributes (editorState) {
                const trackPluginState = $1bf8747c56e383f6$export$a79cdfb4b852386b.getState(editorState);
                return {
                    ['data-has-collab-initialised']: `${Boolean(trackPluginState?.collabInitialisedAt)}`
                };
            }
        }
    });
};


















var $25jxS = parcelRequire("25jxS");


var $kt8c2 = parcelRequire("kt8c2");

const $fc787c08799122c8$var$storageClient = new (0, $kt8c2.default)((0, $25jxS.NCS_STORAGE).NCS_STORAGE_CLIENT_KEY);
const $fc787c08799122c8$export$4fe9abcf7996805c = (metrics, sessionId, steps)=>{
    const current = metrics[sessionId] ?? {
        ncsSessionId: sessionId,
        totalStepSize: 0,
        numberOfSteps: 0,
        maxStepSize: 0,
        stepSizeSumForP90: []
    };
    steps.forEach((step)=>{
        const stepSize = JSON.stringify(step).length;
        current.totalStepSize += stepSize;
        current.numberOfSteps += 1;
        current.maxStepSize = Math.max(current.maxStepSize, stepSize || 0);
        current.stepSizeSumForP90.push(stepSize || 0);
    });
    return current;
};
const $fc787c08799122c8$export$bc7fe0d8ce4c3c0a = (sessionId)=>{
    const currentActiveSessions = JSON.parse($fc787c08799122c8$var$storageClient.getItem((0, $25jxS.NCS_STORAGE).NCS_ACTIVE_SESSIONS) || '{}');
    if (!currentActiveSessions[sessionId]) $fc787c08799122c8$var$storageClient.setItemWithExpiry((0, $25jxS.NCS_STORAGE).NCS_ACTIVE_SESSIONS, JSON.stringify({
        ...currentActiveSessions,
        [sessionId]: true
    }));
};
const $fc787c08799122c8$export$defdcaf9cc1c87fe = ({ api: api, steps: steps })=>{
    const sessionId = api?.collabEdit?.sharedState.currentState()?.sessionId;
    if (!sessionId) return;
    const existingMetrics = JSON.parse($fc787c08799122c8$var$storageClient.getItem((0, $25jxS.NCS_STORAGE).NCS_SESSION_STEP_METRICS) || '{}');
    const ncsSessionStepMetrics = $fc787c08799122c8$export$4fe9abcf7996805c(existingMetrics, sessionId, steps);
    $fc787c08799122c8$var$storageClient.setItemWithExpiry((0, $25jxS.NCS_STORAGE).NCS_SESSION_STEP_METRICS, JSON.stringify({
        ...existingMetrics,
        [sessionId]: ncsSessionStepMetrics
    }));
    $fc787c08799122c8$export$bc7fe0d8ce4c3c0a(sessionId);
};


function $1d34501b5af9fe4b$var$groupBy(array, keyGetter) {
    // Check group by exists, and that it's a function. If so, use the native browser code
    if ('groupBy' in Object && typeof Object.groupBy === 'function') // @ts-ignore TS2322 - Type 'Partial<Record<string, T[]>>' is not assignable to type 'Record<string, T[]>'.
    return Object.groupBy(array, keyGetter);
    // Fallback to custom implementation
    const map = {};
    array.forEach((item)=>{
        const key = keyGetter(item);
        if (!map[key]) map[key] = [];
        map[key].push(item);
    });
    return map;
}
const $1d34501b5af9fe4b$export$685b976035d234a6 = (step)=>{
    const serializedStep = step.toJSON();
    const sanitizedStep = {
        stepType: serializedStep.stepType
    };
    if (step instanceof (0, $aXG5V.AttrStep) || step instanceof (0, $aXG5V.DocAttrStep)) sanitizedStep.attr = step.attr;
    else if (step instanceof (0, $c3x1B.SetAttrsStep)) // Combines all attrs keys separated by _ to one single string
    sanitizedStep.attr = Object.keys(step.attrs).sort().join('_');
    else if (step instanceof (0, $aXG5V.AddMarkStep) || step instanceof (0, $aXG5V.RemoveMarkStep) || step instanceof (0, $aXG5V.RemoveNodeMarkStep) || step instanceof (0, $aXG5V.AddNodeMarkStep)) sanitizedStep.markType = step.mark.type.name;
    return sanitizedStep;
};
const $1d34501b5af9fe4b$export$cb21deee7d469afa = (sanitizedSteps)=>{
    const grouped = $1d34501b5af9fe4b$var$groupBy(sanitizedSteps, (e)=>Object.values(e).join('_'));
    return Object.entries(grouped).reduce((acc, [key, value])=>{
        acc[key] = Array.isArray(value) ? value.length : 0;
        return acc;
    }, {});
};
const $1d34501b5af9fe4b$export$94e939b87ca64fb4 = (cache, onTrackDataProcessed)=>{
    const stepsMetadata = [];
    for (const entry of cache.values()){
        const { startedAt: startedAt, endedAt: endedAt, steps: steps } = entry;
        const stepTypesAmount = $1d34501b5af9fe4b$export$cb21deee7d469afa(steps.map($1d34501b5af9fe4b$export$685b976035d234a6));
        stepsMetadata.push({
            startedAt: startedAt,
            endedAt: endedAt,
            stepTypesAmount: stepTypesAmount
        });
    }
    cache.clear();
    if (stepsMetadata.length > 0) onTrackDataProcessed(stepsMetadata);
};
const $1d34501b5af9fe4b$var$stepsSentCache = new Map();
// Every ten seconds we will try to process the step data.
const $1d34501b5af9fe4b$var$LOW_PRIORITY_DELAY = 10000;
const $1d34501b5af9fe4b$var$getScheduler = (// Our TypeScript configuration isn't ready for the Scheduler API https://developer.mozilla.org/en-US/docs/Web/API/Scheduler/ (yet)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
obj)=>{
    if (!obj) return null;
    if ('scheduler' in obj) return obj.scheduler;
    return null;
};
const $1d34501b5af9fe4b$export$6b2a7d5132615086 = ({ api: api, newEditorState: newEditorState, transactions: transactions, onTrackDataProcessed: onTrackDataProcessed })=>{
    const newSteps = transactions.flatMap((t)=>t.steps);
    const collabState = (0, $9NwnH.sendableSteps)(newEditorState);
    const scheduler = $1d34501b5af9fe4b$var$getScheduler(window);
    if (!newSteps.length || !scheduler || !collabState) return;
    const { version: version } = collabState;
    const buffer = $1d34501b5af9fe4b$var$stepsSentCache.get(version);
    const startedAt = buffer?.startedAt || Date.now();
    const endedAt = Date.now();
    const steps = (buffer?.steps || []).concat(newSteps);
    $1d34501b5af9fe4b$var$stepsSentCache.set(version, {
        startedAt: startedAt,
        endedAt: endedAt,
        steps: steps
    });
    (0, $fc787c08799122c8$export$defdcaf9cc1c87fe)({
        api: api,
        steps: (0, $iu6m9.editorExperiment)('platform_editor_reduce_noisy_steps_ncs', true) ? newSteps.filter((step)=>!(step instanceof (0, $4XhNP.AnalyticsStep))) : newSteps
    });
    scheduler.postTask(()=>{
        $1d34501b5af9fe4b$export$94e939b87ca64fb4($1d34501b5af9fe4b$var$stepsSentCache, onTrackDataProcessed);
    }, {
        priority: 'background',
        delay: $1d34501b5af9fe4b$var$LOW_PRIORITY_DELAY
    });
};



const $8f81d195b82ccad2$var$providerBuilder = (collabEditProviderPromise)=>async (codeToExecute, onError)=>{
        try {
            const provider = await collabEditProviderPromise;
            if (provider) return codeToExecute(provider);
        } catch (err) {
            if (onError) onError(err);
            else // eslint-disable-next-line no-console
            console.error(err);
        }
    };
const $8f81d195b82ccad2$var$createAddInlineCommentMark = (providerPromise)=>({ from: from, to: to, mark: mark })=>{
        providerPromise.then((provider)=>{
            const commentMark = new (0, $aXG5V.AddMarkStep)(Math.min(from, to), Math.max(from, to), mark);
            // @ts-expect-error 2339: Property 'api' does not exist on type 'CollabEditProvider<CollabEvents>'.
            provider.api?.addComment([
                commentMark
            ]);
        });
        return false;
    };
const $8f81d195b82ccad2$var$createAddInlineCommentNodeMark = (providerPromise)=>({ pos: pos, mark: mark })=>{
        providerPromise.then((provider)=>{
            const commentMark = new (0, $aXG5V.AddNodeMarkStep)(pos, mark);
            // @ts-expect-error 2339: Property 'api' does not exist on type 'CollabEditProvider<CollabEvents>'.
            provider.api?.addComment([
                commentMark
            ]);
        });
        return false;
    };
const $8f81d195b82ccad2$export$7b59344e4e475116 = ({ config: options, api: api })=>{
    const featureFlags = api?.featureFlags?.sharedState.currentState() || {};
    let providerResolver = ()=>{};
    const editorViewRef = {
        current: null
    };
    const collabEditProviderPromise = new Promise((_providerResolver)=>{
        providerResolver = _providerResolver;
    });
    const executeProviderCode = $8f81d195b82ccad2$var$providerBuilder(collabEditProviderPromise);
    return {
        name: 'collabEdit',
        getSharedState (state) {
            if (!state) return {
                initialised: {
                    collabInitialisedAt: null,
                    firstChangeAfterInitAt: null,
                    firstContentBodyChangeAfterInitAt: null,
                    lastLocalOrganicChangeAt: null,
                    lastRemoteOrganicChangeAt: null,
                    lastLocalOrganicBodyChangeAt: null,
                    lastRemoteOrganicBodyChangeAt: null
                },
                activeParticipants: undefined,
                sessionId: undefined,
                lastReconnectionConflictMetadata: undefined
            };
            const collabPluginState = (0, $66421dcbcc8122ef$export$18d4026d1ea86bb1).getState(state);
            const metadata = (0, $1bf8747c56e383f6$export$a79cdfb4b852386b).getState(state);
            const lastOrganicChangeState = (0, $c97c8d128269dcfd$export$e968e014d3efd8b6).getState(state);
            const lastRemoteConflict = (0, $dff7c070b048fc1b$export$1fa2affd5117a057).getState(state);
            return {
                activeParticipants: collabPluginState?.activeParticipants,
                sessionId: collabPluginState?.sessionId,
                initialised: {
                    collabInitialisedAt: metadata?.collabInitialisedAt || null,
                    firstChangeAfterInitAt: metadata?.firstChangeAfterInitAt || null,
                    firstContentBodyChangeAfterInitAt: metadata?.firstContentBodyChangeAfterInitAt || null,
                    lastLocalOrganicChangeAt: lastOrganicChangeState?.lastLocalOrganicChangeAt || null,
                    lastRemoteOrganicChangeAt: lastOrganicChangeState?.lastRemoteOrganicChangeAt || null,
                    lastLocalOrganicBodyChangeAt: lastOrganicChangeState?.lastLocalOrganicBodyChangeAt || null,
                    lastRemoteOrganicBodyChangeAt: lastOrganicChangeState?.lastRemoteOrganicBodyChangeAt || null
                },
                lastReconnectionConflictMetadata: lastRemoteConflict
            };
        },
        actions: {
            getAvatarColor: $251f784cd31b0be3$export$90c6ee000c44ff4a,
            addInlineCommentMark: $8f81d195b82ccad2$var$createAddInlineCommentMark(collabEditProviderPromise),
            addInlineCommentNodeMark: $8f81d195b82ccad2$var$createAddInlineCommentNodeMark(collabEditProviderPromise),
            isRemoteReplaceDocumentTransaction: (tr)=>tr.getMeta('isRemote') && tr.getMeta('replaceDocument'),
            getCurrentCollabState: ()=>{
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                const adfDocument = new (0, $h9yJL.JSONTransformer)().encode(editorViewRef.current.state.doc);
                return {
                    content: adfDocument,
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    version: (0, $9NwnH.getCollabState)(editorViewRef.current.state)?.version || 0,
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    sendableSteps: (0, $9NwnH.sendableSteps)(editorViewRef.current.state)
                };
            },
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            validatePMJSONDocument: (doc)=>{
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const content = (doc.content || []).map((child)=>// Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    editorViewRef.current.state.schema.nodeFromJSON(child));
                return content.every((node)=>{
                    try {
                        node.check(); // this will throw an error if the node is invalid
                    } catch (error) {
                        return false;
                    }
                    return true;
                });
            }
        },
        pmPlugins () {
            const { useNativePlugin: useNativePlugin = false, userId: userId = null } = options || {};
            const transformUnconfirmed = (steps)=>{
                let transformed = steps;
                if ((0, $iu6m9.editorExperiment)('platform_editor_reduce_noisy_steps_ncs', true, {
                    exposure: true
                })) transformed = (0, $b0d3b33c6517a237$export$75962d04b28eb982)(transformed);
                if ((0, $iu6m9.editorExperiment)('platform_editor_offline_editing_web', true) || (0, $1oCLl.expValEquals)('platform_editor_enable_single_player_step_merging', 'isEnabled', true)) transformed = (0, $535e7c47bdfe9cbe$export$8e3092acded15d5d)(transformed, api);
                return transformed;
            };
            const plugins = [
                ...useNativePlugin ? [
                    {
                        name: 'pmCollab',
                        plugin: ()=>(0, $9NwnH.collab)({
                                clientID: userId,
                                transformUnconfirmed: transformUnconfirmed
                            })
                    },
                    {
                        name: 'nativeCollabProviderPlugin',
                        plugin: ()=>(0, $7ad60ed4c4777fb2$export$ad653665b59b3ffd)({
                                providerPromise: collabEditProviderPromise
                            })
                    }
                ] : [],
                {
                    name: 'collab',
                    plugin: ({ dispatch: dispatch, providerFactory: providerFactory })=>{
                        return (0, $cca91a3622c8da39$export$ae829ec7b2625219)(dispatch, providerFactory, providerResolver, executeProviderCode, options, featureFlags, api);
                    }
                },
                {
                    name: 'collabTrackNCSInitializationPlugin',
                    plugin: (0, $1bf8747c56e383f6$export$ae829ec7b2625219)
                }
            ];
            plugins.push({
                name: 'trackAndFilterSpammingSteps',
                plugin: ()=>(0, $e93f8b61e819792a$export$ae829ec7b2625219)((tr)=>{
                        const sanitizedSteps = tr.steps.map((step)=>(0, $e93f8b61e819792a$export$2d791416d1075a3b)(step));
                        api?.analytics?.actions?.fireAnalyticsEvent({
                            action: (0, $d925B.ACTION).STEPS_FILTERED,
                            actionSubject: (0, $d925B.ACTION_SUBJECT).COLLAB,
                            attributes: {
                                steps: sanitizedSteps
                            },
                            eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL
                        });
                    })
            });
            plugins.push({
                name: 'collabTrackLastOrganicChangePlugin',
                plugin: (0, $c97c8d128269dcfd$export$ae829ec7b2625219)
            });
            if ((0, $iu6m9.editorExperiment)('platform_editor_offline_editing_web', true)) plugins.push({
                name: 'trackLastRemoteConflictPlugin',
                plugin: (0, $dff7c070b048fc1b$export$ae829ec7b2625219)
            });
            return plugins;
        },
        onEditorViewStateUpdated (props) {
            const addErrorAnalytics = (0, $469073082c3fe329$export$8c408a1f4e12c948)(props.newEditorState, props.newEditorState.tr, featureFlags, api?.analytics?.actions);
            const isEmptyDoc = (0, $2pjJ5.isEmptyDocument)(props.newEditorState.doc);
            const viewMode = api?.editorViewMode?.sharedState.currentState()?.mode;
            executeProviderCode((0, $ea4f9fca74c39b80$export$8e0e7ffc78696d30)({
                originalTransaction: props.originalTransaction,
                transactions: props.transactions,
                oldEditorState: props.oldEditorState,
                newEditorState: props.newEditorState,
                useNativePlugin: options.useNativePlugin ?? false,
                hideTelecursorOnLoad: !isEmptyDoc && (options.hideTelecursorOnLoad ?? false),
                viewMode: viewMode
            }), addErrorAnalytics);
            (0, $1d34501b5af9fe4b$export$6b2a7d5132615086)({
                api: api,
                ...props,
                onTrackDataProcessed: (steps)=>{
                    api?.analytics?.actions?.fireAnalyticsEvent({
                        action: (0, $d925B.ACTION).STEPS_TRACKED,
                        actionSubject: (0, $d925B.ACTION_SUBJECT).COLLAB,
                        attributes: {
                            steps: steps
                        },
                        eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL
                    });
                }
            });
        },
        commands: {
            nudgeTelepointer: (sessionId)=>({ tr: tr })=>{
                    tr.setMeta('nudgeTelepointer', {
                        sessionId: sessionId
                    });
                    return tr;
                }
        }
    };
};
module.exports["collabEditPlugin"] = $8f81d195b82ccad2$export$7b59344e4e475116;

});

parcelRegister("8ElOg", function(module, exports) {
$parcel$export(module.exports, "contextPanelPlugin", () => (parcelRequire("1nZXu")).contextPanelPlugin);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $1nZXu = parcelRequire("1nZXu");


});

parcelRegister("aAppb", function(module, exports) {
$parcel$export(module.exports, "extensionPlugin", () => (parcelRequire("eyggb")).extensionPlugin);
// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $eyggb = parcelRequire("eyggb");


});

parcelRegister("efDik", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $ceXmR = parcelRequire("ceXmR");

var $3ZA5r = parcelRequire("3ZA5r");


var $2UWDO = parcelRequire("2UWDO");


var $3pLGZ = parcelRequire("3pLGZ");


var $lEQpi = parcelRequire("lEQpi");


var $5nBzc = parcelRequire("5nBzc");

const $4d87990c851ea68d$export$809659ed37baae65 = (syncBlockStore)=>{
    return syncBlockStore.flushBodiedSyncBlocks();
};



var $d925B = parcelRequire("d925B");


var $kgnzE = parcelRequire("kgnzE");


var $ks2lK = parcelRequire("ks2lK");


var $8m4tT = parcelRequire("8m4tT");


var $5SAOw = parcelRequire("5SAOw");








var $7XFGZ = parcelRequire("7XFGZ");

var $id9O1 = parcelRequire("id9O1");

const $418da91bd772292a$export$8e2da6078c69a0c6 = (schema, selection)=>{
    const { syncBlock: syncBlock } = schema.nodes;
    return (0, $8m4tT.findSelectedNodeOfType)(syncBlock)(selection);
};
const $418da91bd772292a$export$342c143cb64448d1 = (schema, selection)=>{
    return (0, $8m4tT.findSelectedNodeOfType)(schema.nodes.bodiedSyncBlock)(selection) || (0, $8m4tT.findParentNodeOfType)(schema.nodes.bodiedSyncBlock)(selection);
};
const $418da91bd772292a$export$72f89723ce6d6fa3 = (schema, selection)=>{
    return $418da91bd772292a$export$8e2da6078c69a0c6(schema, selection) || $418da91bd772292a$export$342c143cb64448d1(schema, selection);
};
const $418da91bd772292a$export$5f971aa95a01794c = (node, bodiedSyncBlock)=>node.type === bodiedSyncBlock;
const $418da91bd772292a$var$UNSUPPORTED_NODE_TYPES = new Set([
    'inlineExtension',
    'extension',
    'bodiedExtension',
    'syncBlock',
    'bodiedSyncBlock'
]);
const $418da91bd772292a$export$a912fa82dfd54783 = (selection)=>{
    const schema = selection.$from.doc.type.schema;
    const { nodes: nodes } = schema;
    let from = selection.from;
    let to = selection.to;
    let contentToInclude = selection.content().content;
    if (selection instanceof (0, $7XFGZ.CellSelection)) {
        const table = (0, $id9O1.findTable)(selection);
        if (!table) return false;
        contentToInclude = (0, $5SAOw.Fragment).from([
            table.node
        ]);
        from = table.pos;
        to = table.pos + table.node.nodeSize;
    } else if (selection instanceof (0, $ks2lK.TextSelection)) {
        const trueParent = (0, $8m4tT.findParentNodeOfType)([
            nodes.bulletList,
            nodes.orderedList,
            nodes.taskList,
            nodes.blockquote
        ])(selection);
        if (trueParent) {
            contentToInclude = (0, $5SAOw.Fragment).from([
                trueParent.node
            ]);
            from = trueParent.pos;
            to = trueParent.pos + trueParent.node.nodeSize;
        }
    }
    let canBeConverted = true;
    selection.$from.doc.nodesBetween(from, to, (node)=>{
        if ($418da91bd772292a$var$UNSUPPORTED_NODE_TYPES.has(node.type.name)) {
            canBeConverted = false;
            return false;
        }
    });
    if (!canBeConverted) return false;
    contentToInclude = $418da91bd772292a$var$removeBreakoutMarks(contentToInclude);
    return {
        contentToInclude: contentToInclude,
        from: from,
        to: to
    };
};
const $418da91bd772292a$var$removeBreakoutMarks = (content)=>{
    const nodes = [];
    // we only need to recurse at the top level, because breakout has to be on a top level
    content.forEach((node)=>{
        const filteredMarks = node.marks.filter((mark)=>mark.type.name !== 'breakout');
        if (node.isText) nodes.push(node);
        else {
            const newNode = node.type.create(node.attrs, node.content, filteredMarks);
            nodes.push(newNode);
        }
    });
    return (0, $5SAOw.Fragment).from(nodes);
};


const $81d4226bf8406331$export$fbc30658d812c800 = ({ tr: tr, syncBlockStore: syncBlockStore, typeAheadInsert: typeAheadInsert })=>{
    const { schema: { nodes: { bodiedSyncBlock: bodiedSyncBlock, paragraph: paragraph } } } = tr.doc.type;
    // If the selection is empty, we want to insert the sync block on a new line
    if (tr.selection.empty) {
        const attrs = syncBlockStore.generateBodiedSyncBlockAttrs();
        const paragraphNode = paragraph.createAndFill({});
        const newBodiedSyncBlockNode = bodiedSyncBlock.createAndFill(attrs, paragraphNode ? [
            paragraphNode
        ] : []);
        if (!newBodiedSyncBlockNode) return false;
        // Save the new node with empty content to backend
        // This is so that the node can be copied and referenced without the source being saved/published
        syncBlockStore.createBodiedSyncBlockNode(attrs);
        if (typeAheadInsert) tr = typeAheadInsert(newBodiedSyncBlockNode);
        else tr = tr.replaceSelectionWith(newBodiedSyncBlockNode).scrollIntoView();
    } else {
        const conversionInfo = (0, $418da91bd772292a$export$a912fa82dfd54783)(tr.selection);
        if (!conversionInfo) // TODO: EDITOR-1665 - Raise an error analytics event
        return false;
        const attrs = syncBlockStore.generateBodiedSyncBlockAttrs();
        const newBodiedSyncBlockNode = bodiedSyncBlock.createAndFill(attrs, conversionInfo.contentToInclude);
        if (!newBodiedSyncBlockNode) return false;
        // Save the new node with empty content to backend
        // This is so that the node can be copied and referenced without the source being saved/published
        syncBlockStore.createBodiedSyncBlockNode(attrs);
        tr.replaceWith(conversionInfo.from > 0 ? conversionInfo.from - 1 : 0, conversionInfo.to, newBodiedSyncBlockNode).scrollIntoView();
        // set selection to the end of the previous selection + 1 for the position taken up by the start of the new synced block
        tr.setSelection((0, $ks2lK.TextSelection).create(tr.doc, conversionInfo.to + 1));
    }
    // This transaction will be intercepted in filterTransaction and dispatched when saving to backend succeeds
    // see filterTransaction for more details
    return tr;
};
const $81d4226bf8406331$export$c461f640005976aa = ({ tr: tr })=>{
    if ($81d4226bf8406331$var$copySyncedBlockReferenceToClipboardInternal(tr.doc.type.schema, tr.selection)) return tr;
    return null;
};
const $81d4226bf8406331$export$cdf949b884fe546d = (state, _dispatch, _view)=>{
    return $81d4226bf8406331$var$copySyncedBlockReferenceToClipboardInternal(state.tr.doc.type.schema, state.tr.selection);
};
const $81d4226bf8406331$var$copySyncedBlockReferenceToClipboardInternal = (schema, selection)=>{
    const syncBlockFindResult = (0, $418da91bd772292a$export$72f89723ce6d6fa3)(schema, selection);
    if (!syncBlockFindResult) return false;
    const isBodiedSyncBlock = (0, $418da91bd772292a$export$5f971aa95a01794c)(syncBlockFindResult.node, schema.nodes.bodiedSyncBlock);
    let referenceSyncBlockNode = null;
    if (isBodiedSyncBlock) {
        const { nodes: { syncBlock: syncBlock } } = schema;
        // create sync block reference node
        referenceSyncBlockNode = syncBlock.createAndFill({
            resourceId: syncBlockFindResult.node.attrs.resourceId
        });
        if (!referenceSyncBlockNode) return false;
    } else referenceSyncBlockNode = syncBlockFindResult.node;
    if (!referenceSyncBlockNode) return false;
    const domNode = (0, $kgnzE.toDOM)(referenceSyncBlockNode, schema);
    (0, $kgnzE.copyDomNode)(domNode, referenceSyncBlockNode.type, selection);
    return true;
};
const $81d4226bf8406331$export$3a389eb361f43fd = (syncBlockStore, api)=>(state, dispatch, _view)=>{
        const syncBlock = (0, $418da91bd772292a$export$8e2da6078c69a0c6)(state.schema, state.selection);
        const resourceId = syncBlock?.node?.attrs?.resourceId;
        if (!resourceId) return false;
        const syncBlockURL = syncBlockStore.getSyncBlockURL(resourceId);
        if (syncBlockURL) window.open(syncBlockURL, '_blank');
        else {
            const tr = state.tr;
            api?.analytics?.actions?.attachAnalyticsEvent({
                eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
                action: (0, $d925B.ACTION).ERROR,
                actionSubject: (0, $d925B.ACTION_SUBJECT).SYNCED_BLOCK,
                actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).SYNCED_BLOCK_SOURCE_URL,
                attributes: {
                    error: 'No URL resolved for synced block'
                }
            })(tr);
            dispatch?.(tr);
        }
        return true;
    };
const $81d4226bf8406331$export$1c38da93cd68ba6d = (api)=>(state, dispatch, _view)=>{
        const { schema: { nodes: nodes }, tr: tr } = state;
        if (!dispatch) return false;
        let removeTr = tr;
        if ((0, $8m4tT.findSelectedNodeOfType)(nodes.syncBlock)(tr.selection) || (0, $8m4tT.findSelectedNodeOfType)(nodes.bodiedSyncBlock)(tr.selection)) removeTr = (0, $8m4tT.removeSelectedNode)(tr);
        else removeTr = (0, $8m4tT.removeParentNodeOfType)(nodes.bodiedSyncBlock)(tr);
        if (!removeTr) return false;
        dispatch(removeTr);
        api?.core.actions.focus();
        return true;
    };



var $1S4f7 = parcelRequire("1S4f7");


var $3tffm = parcelRequire("3tffm");


var $e6n00 = parcelRequire("e6n00");





var $ftzrq = parcelRequire("ftzrq");


var $ftpVl = parcelRequire("ftpVl");


const $de66a50f644c3a6b$export$aad35c48eac733f9 = (props)=>{
    return (0, $ftpVl.withLazyLoading)({
        nodeName: 'bodiedSyncBlock',
        getNodeViewOptions: ()=>{},
        loader: ()=>{
            const result = (parcelRequire("6PgjL")).then(({ bodiedSyncBlockNodeView: bodiedSyncBlockNodeView })=>{
                return bodiedSyncBlockNodeView(props);
            });
            return result;
        }
    });
};






const $5832e54240da7df5$export$b5b91943b8f2be3 = (props)=>{
    return (0, $ftpVl.withLazyLoading)({
        nodeName: 'syncBlock',
        getNodeViewOptions: ()=>{},
        loader: ()=>{
            const result = (parcelRequire("gkvLd")).then(({ syncBlockNodeView: syncBlockNodeView })=>{
                return syncBlockNodeView(props);
            });
            return result;
        }
    });
};


var $14082efb50d358e2$export$5881677fb314e6d9 = /*#__PURE__*/ function(FLAG_ID) {
    FLAG_ID["CANNOT_DELETE_WHEN_OFFLINE"] = "cannot-delete-when-offline";
    FLAG_ID["CANNOT_EDIT_WHEN_OFFLINE"] = "cannot-edit-when-offline";
    FLAG_ID["CANNOT_CREATE_WHEN_OFFLINE"] = "cannot-create-when-offline";
    return FLAG_ID;
}({});





const $f0b41872391b9bd5$export$6b191088ef76a6be = (view, event, api)=>{
    if (api?.connectivity?.sharedState.currentState()?.mode !== 'offline') return;
    const { bodiedSyncBlock: bodiedSyncBlock } = view.state.schema.nodes;
    const pos = view.posAtCoords({
        left: event.clientX,
        top: event.clientY
    })?.pos;
    if (pos === undefined) return;
    const $pos = view.state.doc.resolve(pos);
    const maybeNode = (0, $8m4tT.findParentNodeOfTypeClosestToPos)($pos, bodiedSyncBlock);
    if (maybeNode) return true;
};











const $ba7e5685057467c9$export$aee83dbd972779dd = (doc, selection, schema)=>{
    const { bodiedSyncBlock: bodiedSyncBlock } = schema.nodes;
    const syncBlockParent = (0, $8m4tT.findParentNodeOfType)(bodiedSyncBlock)(selection);
    if (syncBlockParent) {
        const { node: node, pos: pos } = syncBlockParent;
        const decoration = (0, $ftzrq.Decoration).node(pos, pos + node.nodeSize, {
            class: `${(0, $e6n00.BodiedSyncBlockSharedCssClassName).selectionInside}`
        });
        return (0, $ftzrq.DecorationSet).create(doc, [
            decoration
        ]);
    }
    return (0, $ftzrq.DecorationSet).empty;
};



var $aXG5V = parcelRequire("aXG5V");




const $f6423e1964ba14ae$export$a1196481035d4d42 = (predicate, tr, state)=>{
    const removed = {};
    const added = {};
    // and cast to specific step types
    const replaceSteps = tr.steps.filter((step)=>step instanceof (0, $aXG5V.ReplaceStep) || step instanceof (0, $aXG5V.ReplaceAroundStep));
    replaceSteps.forEach((step)=>{
        const { from: from, to: to } = step;
        // replaced a range, check for deleted syncBlock
        if (from !== to) step.getMap().forEach((oldStart, oldEnd)=>{
            if (oldStart !== oldEnd) {
                const deletedSlice = state.doc.slice(oldStart, oldEnd);
                deletedSlice.content.nodesBetween(0, deletedSlice.content.size, (node)=>{
                    if (predicate(node)) {
                        if (added[node.attrs.localId]) // If a source block added and then removed in the same transaction,
                        // we treat it as no-op.
                        delete added[node.attrs.localId];
                        else removed[node.attrs.localId] = node.attrs;
                    }
                    // we don't need to go deeper
                    return false;
                });
            }
        });
        // replaced content, check for inserted syncBlock
        // if only one replace step, we have already checked the entire replaced range above
        if (step.slice.content.size > 0) step.slice.content.nodesBetween(0, step.slice.content.size, (node)=>{
            if (predicate(node)) {
                if (removed[node.attrs.localId]) // If a source block is removed and added back in the same transaction,
                // we treat it as no-op.
                delete removed[node.attrs.localId];
                else added[node.attrs.localId] = node.attrs;
            }
            // we don't need to go deeper
            return false;
        });
    });
    return {
        removed: Object.values(removed),
        added: Object.values(added)
    };
};
const $f6423e1964ba14ae$export$7531459b60818a32 = (tr, state)=>{
    const { bodiedSyncBlock: bodiedSyncBlock } = state.schema.nodes;
    for (const step of tr.steps){
        const map = step.getMap();
        const { doc: doc } = tr;
        const positions = [];
        // Extract positions from steps dynamically based on applicable properties
        if ('from' in step && typeof step.from === 'number' && 'to' in step && typeof step.to === 'number') {
            const { from: from, to: to } = step;
            positions.push(from, to);
        } else if ('pos' in step && typeof step.pos === 'number') {
            const { pos: pos } = step;
            positions.push(pos);
        }
        for (const pos of positions){
            const newPos = map.map(pos);
            if (newPos >= 0 && newPos <= doc.content.size) {
                if ((0, $8m4tT.findParentNodeOfTypeClosestToPos)(doc.resolve(newPos), bodiedSyncBlock)) return true;
            }
        }
    }
    return false;
};


const $7e859723415648c3$export$cb5a03b39dafc9cc = new (0, $ks2lK.PluginKey)('syncedBlockPlugin');
const $7e859723415648c3$export$ae829ec7b2625219 = (options, pmPluginFactoryParams, syncBlockStore, api)=>{
    const { useLongPressSelection: useLongPressSelection = false } = options || {};
    return new (0, $1S4f7.SafePlugin)({
        key: $7e859723415648c3$export$cb5a03b39dafc9cc,
        state: {
            init (_, instance) {
                const syncBlockNodes = instance.doc.children.filter((node)=>node.type.name === 'syncBlock');
                syncBlockStore.fetchSyncBlocksData(syncBlockNodes);
                return {
                    selectionDecorationSet: (0, $ba7e5685057467c9$export$aee83dbd972779dd)(instance.doc, instance.selection, instance.schema),
                    showFlag: false
                };
            },
            apply: (tr, currentPluginState, oldEditorState)=>{
                const meta = tr.getMeta($7e859723415648c3$export$cb5a03b39dafc9cc);
                const { showFlag: showFlag, selectionDecorationSet: selectionDecorationSet } = currentPluginState;
                let newDecorationSet = selectionDecorationSet.map(tr.mapping, tr.doc);
                if (!tr.selection.eq(oldEditorState.selection)) newDecorationSet = (0, $ba7e5685057467c9$export$aee83dbd972779dd)(tr.doc, tr.selection, tr.doc.type.schema);
                return {
                    showFlag: meta?.showFlag ?? showFlag,
                    selectionDecorationSet: newDecorationSet
                };
            }
        },
        props: {
            nodeViews: {
                syncBlock: (0, $5832e54240da7df5$export$b5b91943b8f2be3)({
                    options: options,
                    pmPluginFactoryParams: pmPluginFactoryParams,
                    api: api,
                    syncBlockStore: syncBlockStore
                }),
                bodiedSyncBlock: (0, $de66a50f644c3a6b$export$aad35c48eac733f9)({
                    pluginOptions: options,
                    pmPluginFactoryParams: pmPluginFactoryParams,
                    api: api,
                    syncBlockStore: syncBlockStore
                })
            },
            decorations: (state)=>{
                const selectionDecorationSet = $7e859723415648c3$export$cb5a03b39dafc9cc.getState(state)?.selectionDecorationSet ?? (0, $ftzrq.DecorationSet).empty;
                const { doc: doc } = state;
                const decorations = [];
                if (api?.connectivity?.sharedState.currentState()?.mode === 'offline') state.doc.descendants((node, pos)=>{
                    if (node.type.name === 'bodiedSyncBlock') decorations.push((0, $ftzrq.Decoration).node(pos, pos + node.nodeSize, {
                        class: (0, $e6n00.SyncBlockStateCssClassName).disabledClassName
                    }));
                });
                return selectionDecorationSet.add(doc, decorations);
            },
            handleClickOn: (0, $3tffm.createSelectionClickHandler)([
                'bodiedSyncBlock'
            ], (target)=>!!target.closest(`.${(0, $e6n00.BodiedSyncBlockSharedCssClassName).prefix}`), {
                useLongPressSelection: useLongPressSelection
            }),
            handleDOMEvents: {
                mouseover (view, event) {
                    return (0, $f0b41872391b9bd5$export$6b191088ef76a6be)(view, event, api);
                },
                mousedown (view, event) {
                    return (0, $f0b41872391b9bd5$export$6b191088ef76a6be)(view, event, api);
                }
            }
        },
        view: (editorView)=>{
            syncBlockStore.setEditorView(editorView);
            return {
                destroy () {
                    syncBlockStore.setEditorView(undefined);
                }
            };
        },
        filterTransaction: (tr, state)=>{
            const isOffline = api?.connectivity?.sharedState.currentState()?.mode === 'offline';
            const isConfirmedSyncBlockDeletion = Boolean(tr.getMeta('isConfirmedSyncBlockDeletion'));
            // Ignore transactions that don't change the document
            // or are from remote (collab) or already confirmed sync block deletion
            // We only care about local changes that change the document
            // and are not yet confirmed for sync block deletion
            if (!tr.docChanged || !syncBlockStore?.requireConfirmationBeforeDelete() && !syncBlockStore.hasPendingCreation() || Boolean(tr.getMeta('isRemote')) || Boolean(tr.getMeta('isCommitSyncBlockCreation')) || !isOffline && isConfirmedSyncBlockDeletion) return true;
            const { removed: bodiedSyncBlockRemoved, added: bodiedSyncBlockAdded } = (0, $f6423e1964ba14ae$export$a1196481035d4d42)(syncBlockStore.isSourceBlock, tr, state);
            if (!isOffline) {
                if (bodiedSyncBlockRemoved.length > 0) {
                    // If there are source sync blocks being removed, and we need to confirm with user before deleting,
                    // we block the transaction here, and wait for user confirmation to proceed with deletion.
                    // See editor-common/src/sync-block/sync-block-store-manager.ts for how we handle user confirmation and
                    // proceed with deletion.
                    syncBlockStore.deleteSyncBlocksWithConfirmation(tr, bodiedSyncBlockRemoved);
                    return false;
                }
                if (bodiedSyncBlockAdded.length > 0) {
                    // If there is bodiedSyncBlock node addition and it's waiting for the result of saving the node to backend (syncBlockStore.hasPendingCreation()),
                    // we need to intercept the transaction and save it in insert callback so that we only insert it to the document when backend call if backend call is successful
                    // The callback will be evoked by in SourceSyncBlockStoreManager.commitPendingCreation
                    syncBlockStore.registerCreationCallback(()=>{
                        api?.core?.actions.execute(()=>{
                            return tr.setMeta('isCommitSyncBlockCreation', true);
                        });
                        api?.core.actions.focus();
                    });
                    return false;
                }
            } else {
                // Disable (bodied)syncBlock node deletion/creation/edition in offline mode and trigger an error flag instead
                const { removed: syncBlockRemoved, added: syncBlockAdded } = (0, $f6423e1964ba14ae$export$a1196481035d4d42)((node)=>node.type.name === 'syncBlock', tr, state);
                let errorFlag = false;
                if (isConfirmedSyncBlockDeletion || bodiedSyncBlockRemoved.length > 0 || syncBlockRemoved.length > 0) errorFlag = (0, $14082efb50d358e2$export$5881677fb314e6d9).CANNOT_DELETE_WHEN_OFFLINE;
                else if (bodiedSyncBlockAdded.length > 0 || syncBlockAdded.length > 0) errorFlag = (0, $14082efb50d358e2$export$5881677fb314e6d9).CANNOT_CREATE_WHEN_OFFLINE;
                else if ((0, $f6423e1964ba14ae$export$7531459b60818a32)(tr, state)) errorFlag = (0, $14082efb50d358e2$export$5881677fb314e6d9).CANNOT_EDIT_WHEN_OFFLINE;
                if (errorFlag) {
                    // Use setTimeout to dispatch transaction in next tick and avoid re-entrant dispatch
                    setTimeout(()=>{
                        api?.core.actions.execute(({ tr: tr })=>{
                            return tr.setMeta($7e859723415648c3$export$cb5a03b39dafc9cc, {
                                showFlag: errorFlag
                            });
                        });
                    }, 0);
                    return false;
                }
            }
            return true;
        },
        appendTransaction: (trs, _oldState, newState)=>{
            trs.filter((tr)=>tr.docChanged).forEach((tr)=>{
                syncBlockStore?.rebaseTransaction(tr, newState);
            });
            return null;
        }
    });
};





parcelRequire("42omo");


var $btNLq = parcelRequire("btNLq");

var $gEb6G = parcelRequire("gEb6G");





var $42omo = parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $eiA8Z = parcelRequire("eiA8Z");


var $eKkkY = parcelRequire("eKkkY");


var $l1bBg = parcelRequire("l1bBg");

var $2GVu1 = parcelRequire("2GVu1");





const $f4f4a9661e1724d7$var$CreateSyncedBlockDropdownItem = ({ api: api })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { selection: selection, menuTriggerByNode: menuTriggerByNode, mode: mode } = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'selection',
        'blockControls',
        'connectivity'
    ], (states)=>({
            selection: states.selectionState?.selection,
            menuTriggerByNode: states.blockControlsState?.menuTriggerByNode ?? undefined,
            mode: states.connectivityState?.mode
        }));
    const isNested = menuTriggerByNode && menuTriggerByNode.rootPos !== menuTriggerByNode.pos;
    const canBeConverted = (0, $42omo.useMemo)(()=>selection && (0, $418da91bd772292a$export$a912fa82dfd54783)(selection), [
        selection
    ]);
    if (isNested || !canBeConverted) return null;
    const onClick = ()=>{
        api?.core?.actions.execute(api?.syncedBlock.commands.insertSyncedBlock());
        api?.core?.actions.execute(api?.blockControls?.commands?.toggleBlockMenu({
            closeMenu: true
        }));
    };
    const isOffline = mode === 'offline';
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $2GVu1.ToolbarDropdownItem), {
        elemBefore: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($l1bBg))), {
            label: ""
        }),
        onClick: onClick,
        isDisabled: isOffline,
        elemAfter: /*#__PURE__*/ (0, $l998X.jsx)((0, $5nBzc.default), {
            appearance: "new",
            children: formatMessage((0, $eKkkY.messages).newLozenge)
        }),
        children: formatMessage((0, $eKkkY.messages).createSyncedBlock)
    });
};
const $f4f4a9661e1724d7$var$CopySyncedBlockDropdownItem = ({ api: api })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { mode: mode } = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'connectivity'
    ], (states)=>({
            mode: states.connectivityState?.mode
        }));
    const onClick = ()=>{
        api?.core?.actions.execute(api?.syncedBlock.commands.copySyncedBlockReferenceToClipboard());
        api?.core?.actions.execute(api?.blockControls?.commands?.toggleBlockMenu({
            closeMenu: true
        }));
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $2GVu1.ToolbarDropdownItem), {
        elemBefore: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($l1bBg))), {
            label: ""
        }),
        onClick: onClick,
        isDisabled: mode === 'offline',
        elemAfter: /*#__PURE__*/ (0, $l998X.jsx)((0, $5nBzc.default), {
            appearance: "new",
            children: formatMessage((0, $eKkkY.messages).newLozenge)
        }),
        children: formatMessage((0, $eKkkY.messages).copySyncedBlock)
    });
};
const $f4f4a9661e1724d7$export$3699afce8ee13fa8 = ({ api: api })=>{
    const { menuTriggerByNode: menuTriggerByNode } = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'blockControls'
    ], (states)=>({
            menuTriggerByNode: states.blockControlsState?.menuTriggerByNode ?? undefined
        }));
    if (menuTriggerByNode?.nodeType === 'syncBlock' || menuTriggerByNode?.nodeType === 'bodiedSyncBlock') return /*#__PURE__*/ (0, $l998X.jsx)($f4f4a9661e1724d7$var$CopySyncedBlockDropdownItem, {
        api: api
    });
    else return /*#__PURE__*/ (0, $l998X.jsx)($f4f4a9661e1724d7$var$CreateSyncedBlockDropdownItem, {
        api: api
    });
};


const $bfc48e23a08c3f1f$export$b1be7b75e24fc24b = (api)=>{
    return [
        {
            type: 'block-menu-item',
            key: (0, $btNLq.CREATE_SYNCED_BLOCK_MENU_ITEM).key,
            parent: {
                type: 'block-menu-section',
                key: (0, $btNLq.ADD_BLOCKS_MENU_SECTION).key,
                rank: (0, $gEb6G.ADD_BLOCKS_MENU_SECTION_RANK)[(0, $btNLq.CREATE_SYNCED_BLOCK_MENU_ITEM).key]
            },
            component: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $f4f4a9661e1724d7$export$3699afce8ee13fa8), {
                    api: api
                })
        }
    ];
};












var $ccHMk = parcelRequire("ccHMk");





var $fzXn1 = parcelRequire("fzXn1");


var $8CZUH = parcelRequire("8CZUH");

var $1DHa6 = parcelRequire("1DHa6");

var $8o1lj = parcelRequire("8o1lj");

var $9ot3w = parcelRequire("9ot3w");

var $d8eRd = parcelRequire("d8eRd");

var $6xdDU = parcelRequire("6xdDU");


var $iXCQx = parcelRequire("iXCQx");

const $36d8a16884645580$export$d973532b09e0f2cc = ({ syncBlockStoreManager: syncBlockStoreManager, api: api })=>{
    const [isOpen, setIsOpen] = (0, $42omo.useState)(false);
    const [syncBlockCount, setSyncBlockCount] = (0, $42omo.useState)(1);
    const { mode: mode } = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'connectivity'
    ], (states)=>({
            mode: states.connectivityState?.mode
        }));
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const resolverRef = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef(undefined);
    const handleClose = (0, $42omo.useCallback)((confirm)=>()=>{
            if (resolverRef.current) {
                resolverRef.current(confirm);
                resolverRef.current = undefined;
            }
            setIsOpen(false);
        }, []);
    const confirmationCallback = (0, $42omo.useCallback)((syncBlockCount)=>{
        setIsOpen(true);
        setSyncBlockCount(syncBlockCount);
        const confirmedPromise = new Promise((resolve)=>{
            resolverRef.current = resolve;
        });
        return confirmedPromise;
    }, []);
    (0, $42omo.useEffect)(()=>{
        const unregister = syncBlockStoreManager.registerConfirmationCallback(confirmationCallback);
        return ()=>{
            unregister();
        };
    }, [
        syncBlockStoreManager,
        confirmationCallback
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6xdDU.default), {
        children: isOpen && /*#__PURE__*/ (0, $l998X.jsxs)((0, $8CZUH.default), {
            onClose: handleClose(false),
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $9ot3w.default), {
                    hasCloseButton: true,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $d8eRd.default), {
                        appearance: "warning",
                        children: formatMessage((0, $fzXn1.syncBlockMessages).deleteConfirmationModalTitle)
                    })
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $1DHa6.default), {
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                        children: formatMessage((0, $fzXn1.syncBlockMessages).deleteConfirmationModalDescription, {
                            syncBlockCount: syncBlockCount
                        })
                    })
                }),
                /*#__PURE__*/ (0, $l998X.jsxs)((0, $8o1lj.default), {
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                            appearance: "subtle",
                            onClick: handleClose(false),
                            children: formatMessage((0, $fzXn1.syncBlockMessages).deleteConfirmationModalCancelButton)
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                            appearance: "warning",
                            onClick: handleClose(true),
                            autoFocus: true,
                            isDisabled: mode === 'offline',
                            children: formatMessage((0, $fzXn1.syncBlockMessages).deleteConfirmationModalDeleteButton)
                        })
                    ]
                })
            ]
        })
    });
};





parcelRequire("42omo");











var $eCEXz = parcelRequire("eCEXz");

var $6uGcC = parcelRequire("6uGcC");


var $a3fRD = parcelRequire("a3fRD");



const $52c5140df34ff9d4$var$flagMap = {
    [(0, $14082efb50d358e2$export$5881677fb314e6d9).CANNOT_DELETE_WHEN_OFFLINE]: {
        title: (0, $fzXn1.syncBlockMessages).failToDeleteTitle,
        description: (0, $fzXn1.syncBlockMessages).failToDeleteWhenOfflineDescription
    },
    [(0, $14082efb50d358e2$export$5881677fb314e6d9).CANNOT_EDIT_WHEN_OFFLINE]: {
        title: (0, $fzXn1.syncBlockMessages).failToEditTitle,
        description: (0, $fzXn1.syncBlockMessages).failToEditWhenOfflineDescription
    },
    [(0, $14082efb50d358e2$export$5881677fb314e6d9).CANNOT_CREATE_WHEN_OFFLINE]: {
        title: (0, $fzXn1.syncBlockMessages).failToCreateTitle,
        description: (0, $fzXn1.syncBlockMessages).failToCreateWhenOfflineDescription
    }
};
const $52c5140df34ff9d4$export$48ea269755562084 = ({ api: api })=>{
    const { showFlag: showFlag } = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'syncedBlock'
    ], (states)=>{
        return {
            showFlag: states.syncedBlockState?.showFlag
        };
    });
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    if (!showFlag) return;
    const { title: title, description: description } = $52c5140df34ff9d4$var$flagMap[showFlag];
    const onDismissed = ()=>{
        api?.core.actions.execute(({ tr: tr })=>{
            tr.setMeta((0, $7e859723415648c3$export$cb5a03b39dafc9cc), {
                showFlag: false
            });
            return tr;
        });
        api?.core.actions.focus();
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6uGcC.default), {
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $eCEXz.default), {
            onDismissed: onDismissed,
            title: formatMessage(title),
            description: formatMessage(description),
            id: showFlag,
            testId: showFlag,
            icon: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($a3fRD))), {
                label: "",
                color: "var(--ds-icon-danger, #C9372C)"
            })
        })
    });
};





parcelRequire("42omo");


var $61p3e = parcelRequire("61p3e");







var $aFUXX = parcelRequire("aFUXX");


var $2MuFw = parcelRequire("2MuFw");


var $gKvd9 = parcelRequire("gKvd9");


var $8tdj3 = parcelRequire("8tdj3");



const $4bceb7bfa67a58a2$export$86ce8f8241c20a3 = (state, intl, api, syncBlockStore)=>{
    const syncBlockObject = (0, $418da91bd772292a$export$72f89723ce6d6fa3)(state.schema, state.selection);
    if (!syncBlockObject) return;
    const { schema: { nodes: { bodiedSyncBlock: bodiedSyncBlock } } } = state;
    const isBodiedSyncBlock = (0, $418da91bd772292a$export$5f971aa95a01794c)(syncBlockObject.node, bodiedSyncBlock);
    const { formatMessage: formatMessage } = intl;
    const nodeType = syncBlockObject.node.type;
    const hoverDecoration = api?.decorations?.actions.hoverDecoration;
    const hoverDecorationProps = (nodeType, className)=>({
            onMouseEnter: hoverDecoration?.(nodeType, true, className),
            onMouseLeave: hoverDecoration?.(nodeType, false, className),
            onFocus: hoverDecoration?.(nodeType, true, className),
            onBlur: hoverDecoration?.(nodeType, false, className)
        });
    const items = [];
    const copyButton = {
        id: 'editor.syncedBlock.copy',
        type: 'button',
        appearance: 'subtle',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($2MuFw))),
        title: formatMessage((0, $fzXn1.syncBlockMessages).copySyncBlockLabel),
        showTitle: false,
        tooltipContent: formatMessage((0, $fzXn1.syncBlockMessages).copySyncBlockTooltip),
        onClick: (0, $81d4226bf8406331$export$cdf949b884fe546d),
        ...hoverDecorationProps(nodeType, (0, $aFUXX.akEditorSelectedNodeClassName))
    };
    items.push(copyButton);
    const disabled = !syncBlockStore.getSyncBlockURL(syncBlockObject.node.attrs.resourceId);
    if (!isBodiedSyncBlock) {
        const editSourceButton = {
            id: 'editor.syncedBlock.editSource',
            type: 'button',
            disabled: disabled,
            appearance: 'subtle',
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($8tdj3))),
            title: formatMessage((0, $fzXn1.syncBlockMessages).editSourceLabel),
            showTitle: true,
            tooltipContent: disabled ? formatMessage((0, $fzXn1.syncBlockMessages).editSourceTooltipDisabled) : formatMessage((0, $fzXn1.syncBlockMessages).editSourceTooltip),
            onClick: (0, $81d4226bf8406331$export$3a389eb361f43fd)(syncBlockStore, api),
            ...hoverDecorationProps(nodeType, (0, $aFUXX.akEditorSelectedNodeClassName))
        };
        items.push(editSourceButton);
    }
    // testId is required to show focus on trigger button on ESC key press
    // see hideOnEsc in platform/packages/editor/editor-plugin-floating-toolbar/src/ui/Dropdown.tsx
    const testId = 'synced-block-overflow-dropdown-trigger';
    const overflowMenuConfig = [
        {
            type: 'overflow-dropdown',
            testId: testId,
            options: [
                {
                    title: formatMessage((0, $61p3e.default).delete),
                    onClick: (0, $81d4226bf8406331$export$1c38da93cd68ba6d)(api),
                    icon: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gKvd9))), {
                        label: ""
                    }),
                    ...hoverDecorationProps(nodeType)
                }
            ]
        }
    ];
    items.push(...overflowMenuConfig);
    const getDomRef = (editorView)=>{
        const domAtPos = editorView.domAtPos.bind(editorView);
        const element = (0, $8m4tT.findDomRefAtPos)(syncBlockObject.pos, domAtPos);
        return element;
    };
    return {
        title: 'Synced Block floating controls',
        getDomRef: getDomRef,
        nodeType: nodeType,
        items: items,
        scrollable: true,
        groupLabel: formatMessage((0, $fzXn1.syncBlockMessages).syncBlockGroup),
        visible: api?.connectivity?.sharedState.currentState()?.mode !== 'offline'
    };
};








const $a5aa0720cf403980$export$800ed13216d179da = 3000;
const $a5aa0720cf403980$export$f8d6f80345184030 = ({ syncBlockStoreManager: syncBlockStoreManager, api: api })=>{
    const { mode: mode } = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'connectivity'
    ], (states)=>({
            mode: states.connectivityState?.mode
        }));
    (0, $42omo.useEffect)(()=>{
        let interval = -1;
        if (mode !== 'offline') interval = window.setInterval(()=>{
            // check if document is visible to avoid unnecessary refreshes
            if (document?.visibilityState === 'visible') syncBlockStoreManager.refreshSubscriptions();
        }, $a5aa0720cf403980$export$800ed13216d179da);
        else if (interval !== -1) window.clearInterval(interval);
        return ()=>{
            window.clearInterval(interval);
        };
    }, [
        syncBlockStoreManager,
        mode
    ]);
    return null;
};





parcelRequire("42omo");


var $cPCP8 = parcelRequire("cPCP8");

var $4Chin = parcelRequire("4Chin");

















var $7ERUE = parcelRequire("7ERUE");

var $iIVVb = parcelRequire("iIVVb");





const $abdbbe21b6af051b$export$954568e298a26ab0 = ({ api: api })=>{
    const intl = (0, $8C5kA.default)();
    const { selection: selection, mode: mode } = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'selection',
        'connectivity'
    ], (states)=>({
            selection: states.selectionState?.selection,
            mode: states.connectivityState?.mode
        }));
    // for toolbar button, we allow both creating a new synced block
    // and converting existing block to synced block
    const canBeConverted = Boolean(selection && (0, $418da91bd772292a$export$a912fa82dfd54783)(selection));
    const canInsertEmptyBlock = Boolean(selection?.empty);
    const isDisabled = Boolean(mode === 'offline' || !canBeConverted && !canInsertEmptyBlock);
    const onClick = (0, $42omo.useCallback)(()=>{
        api?.core?.actions.execute(({ tr: tr })=>api?.syncedBlock.commands.insertSyncedBlock()({
                tr: tr
            }));
        api?.core?.actions.focus();
    }, [
        api
    ]);
    const message = intl.formatMessage((0, $fzXn1.syncBlockMessages).createSyncBlockLabel);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $iIVVb.ToolbarTooltip), {
        content: message,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $7ERUE.ToolbarButton), {
            label: message,
            iconBefore: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($l1bBg))), {
                size: "small",
                label: ""
            }),
            isDisabled: isDisabled,
            onClick: onClick
        })
    });
};



























const $1e1bb42530677831$export$de14b2d4dfd641ee = ({ api: api })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { selection: selection, mode: mode } = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'selection',
        'connectivity'
    ], (states)=>({
            selection: states.selectionState?.selection,
            mode: states.connectivityState?.mode
        }));
    const isDisabled = Boolean(!selection || !(0, $418da91bd772292a$export$a912fa82dfd54783)(selection) || mode === 'offline');
    const onClick = (0, $42omo.useCallback)(()=>{
        api?.core?.actions.execute(({ tr: tr })=>api?.syncedBlock.commands.insertSyncedBlock()({
                tr: tr
            }));
        api?.core?.actions.focus();
    }, [
        api
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $2GVu1.ToolbarDropdownItem), {
        onClick: onClick,
        isDisabled: isDisabled,
        elemBefore: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($l1bBg))), {
            size: "small",
            label: ""
        }),
        elemAfter: /*#__PURE__*/ (0, $l998X.jsx)((0, $5nBzc.default), {
            appearance: "new",
            children: formatMessage((0, $fzXn1.syncBlockMessages).newLozenge)
        }),
        children: formatMessage((0, $fzXn1.syncBlockMessages).createSyncBlockLabel)
    });
};


const $97379743d7c8d373$var$SYNCED_BLOCK_OVERFLOW_MENU_SECTION = {
    type: (0, $cPCP8.SYNCED_BLOCK_SECTION).type,
    key: (0, $cPCP8.SYNCED_BLOCK_SECTION).key,
    parents: [
        {
            type: (0, $cPCP8.OVERFLOW_MENU).type,
            key: (0, $cPCP8.OVERFLOW_MENU).key,
            rank: (0, $4Chin.OVERFLOW_MENU_RANK)[(0, $cPCP8.SYNCED_BLOCK_SECTION).key]
        }
    ]
};
const $97379743d7c8d373$var$SYNCED_BLOCK_PRIMARY_TOOLBAR_GROUP = {
    type: (0, $cPCP8.SYNCED_BLOCK_GROUP).type,
    key: (0, $cPCP8.SYNCED_BLOCK_GROUP).key,
    parents: [
        {
            type: (0, $cPCP8.INSERT_BLOCK_SECTION).type,
            key: (0, $cPCP8.INSERT_BLOCK_SECTION).key,
            rank: (0, $4Chin.INSERT_BLOCK_SECTION_RANK)[(0, $cPCP8.SYNCED_BLOCK_GROUP).key]
        }
    ]
};
const $97379743d7c8d373$export$a758406ca53b86a5 = (api)=>{
    return [
        $97379743d7c8d373$var$SYNCED_BLOCK_PRIMARY_TOOLBAR_GROUP,
        $97379743d7c8d373$var$SYNCED_BLOCK_OVERFLOW_MENU_SECTION,
        {
            type: (0, $cPCP8.SYNCED_BLOCK_BUTTON).type,
            key: (0, $cPCP8.SYNCED_BLOCK_BUTTON).key,
            component: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $abdbbe21b6af051b$export$954568e298a26ab0), {
                    api: api
                }),
            parents: [
                {
                    type: (0, $cPCP8.SYNCED_BLOCK_GROUP).type,
                    key: (0, $cPCP8.SYNCED_BLOCK_GROUP).key,
                    rank: (0, $4Chin.SYNCED_BLOCK_SECTION_RANK)[(0, $cPCP8.SYNCED_BLOCK_BUTTON).key]
                }
            ]
        },
        {
            type: (0, $cPCP8.SYNCED_BLOCK_ITEM).type,
            key: (0, $cPCP8.SYNCED_BLOCK_ITEM).key,
            parents: [
                {
                    type: (0, $cPCP8.SYNCED_BLOCK_SECTION).type,
                    key: (0, $cPCP8.SYNCED_BLOCK_SECTION).key,
                    rank: (0, $4Chin.SYNCED_BLOCK_SECTION_RANK)[(0, $cPCP8.SYNCED_BLOCK_ITEM).key]
                }
            ],
            component: ()=>{
                return /*#__PURE__*/ (0, $l998X.jsx)((0, $1e1bb42530677831$export$de14b2d4dfd641ee), {
                    api: api
                });
            }
        }
    ];
};


const $5a980f14a84d493f$export$4567b5886e253c5a = ({ config: config, api: api })=>{
    const syncBlockStore = new (0, $lEQpi.SyncBlockStoreManager)(config?.syncBlockDataProvider);
    api?.blockMenu?.actions.registerBlockMenuComponents((0, $bfc48e23a08c3f1f$export$b1be7b75e24fc24b)(api));
    api?.toolbar?.actions.registerComponents((0, $97379743d7c8d373$export$a758406ca53b86a5)(api));
    return {
        name: 'syncedBlock',
        nodes () {
            return [
                {
                    name: 'syncBlock',
                    node: (0, $3ZA5r.syncBlock)
                },
                {
                    name: 'bodiedSyncBlock',
                    node: (0, $ceXmR.bodiedSyncBlock)
                }
            ];
        },
        pmPlugins () {
            return [
                {
                    name: 'syncedBlockPlugin',
                    plugin: (params)=>(0, $7e859723415648c3$export$ae829ec7b2625219)(config, params, syncBlockStore, api)
                }
            ];
        },
        commands: {
            copySyncedBlockReferenceToClipboard: ()=>(0, $81d4226bf8406331$export$c461f640005976aa),
            insertSyncedBlock: ()=>({ tr: tr })=>(0, $81d4226bf8406331$export$fbc30658d812c800)({
                        tr: tr,
                        syncBlockStore: syncBlockStore
                    }) || null
        },
        actions: {
            flushBodiedSyncBlocks: ()=>{
                return (0, $4d87990c851ea68d$export$809659ed37baae65)(syncBlockStore);
            }
        },
        pluginsOptions: {
            quickInsert: ({ formatMessage: formatMessage })=>[
                    {
                        id: 'syncBlock',
                        title: formatMessage((0, $2UWDO.messages).syncedBlock),
                        description: formatMessage((0, $2UWDO.messages).syncedBlockDescription),
                        priority: 800,
                        keywords: [
                            'synced',
                            'block',
                            'synced-block',
                            'sync',
                            'sync-block',
                            'auto',
                            'update',
                            'excerpt',
                            'connect'
                        ],
                        isDisabledOffline: true,
                        keyshortcut: '',
                        lozenge: /*#__PURE__*/ (0, $l998X.jsx)((0, $5nBzc.default), {
                            appearance: "new",
                            children: formatMessage((0, $2UWDO.messages).newLozenge)
                        }),
                        icon: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $3pLGZ.IconSyncBlock), {
                                label: formatMessage((0, $2UWDO.messages).syncedBlock)
                            }),
                        action: (insert, state)=>{
                            return (0, $81d4226bf8406331$export$fbc30658d812c800)({
                                tr: state.tr,
                                syncBlockStore: syncBlockStore,
                                typeAheadInsert: insert
                            });
                        }
                    }
                ],
            floatingToolbar: (state, intl)=>(0, $4bceb7bfa67a58a2$export$86ce8f8241c20a3)(state, intl, api, syncBlockStore)
        },
        contentComponent: ()=>{
            return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $a5aa0720cf403980$export$f8d6f80345184030), {
                        syncBlockStoreManager: syncBlockStore,
                        api: api
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $36d8a16884645580$export$d973532b09e0f2cc), {
                        syncBlockStoreManager: syncBlockStore,
                        api: api
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $52c5140df34ff9d4$export$48ea269755562084), {
                        api: api
                    })
                ]
            });
        },
        getSharedState: (editorState)=>{
            if (!editorState) return;
            const { showFlag: showFlag } = (0, $7e859723415648c3$export$cb5a03b39dafc9cc).getState(editorState);
            return {
                showFlag: showFlag
            };
        }
    };
};
module.exports["syncedBlockPlugin"] = $5a980f14a84d493f$export$4567b5886e253c5a;

});

parcelRegister("6PgjL", function(module, exports) {

let $4f8429e183546397$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4f8429e183546397$var$load("9H9aT").then(()=>parcelRequire('d80Tb'));

});

parcelRegister("4mJKd", function(module, exports) {
"use strict";


let $32dcb3648bfd454e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("8tirZ")).shardUrl((parcelRequire("02nRr")).resolve(id), maxShards));
    };
module.exports = $32dcb3648bfd454e$var$load;

});

parcelRegister("8tirZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $62af5803f3d08114$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $62af5803f3d08114$var$getDomainShardIndex;
module.exports.shardUrl = $62af5803f3d08114$var$shardUrl;
module.exports.shardUrlUnchecked = $62af5803f3d08114$var$shardUrlUnchecked;
const $62af5803f3d08114$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $62af5803f3d08114$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $62af5803f3d08114$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $62af5803f3d08114$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $62af5803f3d08114$var$removeTrailingShard(subdomain) {
    if (!$62af5803f3d08114$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $62af5803f3d08114$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$62af5803f3d08114$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $62af5803f3d08114$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $62af5803f3d08114$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $62af5803f3d08114$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $62af5803f3d08114$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $62af5803f3d08114$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$62af5803f3d08114$var$globalKeyName]) return url;
    return $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards);
}
const $62af5803f3d08114$var$domainShardingKey = module.exports.domainShardingKey = $62af5803f3d08114$var$globalKeyName;

});

parcelRegister("02nRr", function(module, exports) {
$parcel$export(module.exports, "register", () => $0072b2502976b004$export$6503ec6e8aabbaf, (v) => $0072b2502976b004$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0072b2502976b004$export$f7ad0328861e2f03, (v) => $0072b2502976b004$export$f7ad0328861e2f03 = v);
var $0072b2502976b004$export$6503ec6e8aabbaf;
var $0072b2502976b004$export$f7ad0328861e2f03;
"use strict";
var $0072b2502976b004$var$mapping = new Map();
function $0072b2502976b004$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0072b2502976b004$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0072b2502976b004$var$resolve(id) {
    var resolved = $0072b2502976b004$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0072b2502976b004$export$6503ec6e8aabbaf = $0072b2502976b004$var$register;
$0072b2502976b004$export$f7ad0328861e2f03 = $0072b2502976b004$var$resolve;

});

parcelRegister("gkvLd", function(module, exports) {

let $be3726970677e46c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $be3726970677e46c$var$load("4shhd"),
    $be3726970677e46c$var$load("87Teh")
]).then(()=>parcelRequire('hoY46'));

});

parcelRegister("3Vesv", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $d925B = parcelRequire("d925B");


var $4HWgE = parcelRequire("4HWgE");


var $3pLGZ = parcelRequire("3pLGZ");

/**
 * Inspired from:
 * https://stackoverflow.com/questions/11219582/how-to-detect-my-browser-version-and-operating-system-using-javascript
 */ const $678a1d6347e818a9$var$getBrowserInfo = (nAgt)=>{
    let browserName;
    let browserVersion;
    let nameOffset;
    let verOffset;
    let index;
    // In Opera 15+, version is after "OPR/"
    // Ignored via go/ees005
    // eslint-disable-next-line no-cond-assign
    if ((verOffset = nAgt.indexOf('OPR/')) !== -1) {
        browserName = 'Opera';
        browserVersion = nAgt.substring(verOffset + 4);
    // Ignored via go/ees005
    // eslint-disable-next-line no-cond-assign
    } else if ((verOffset = nAgt.indexOf('Opera')) !== -1) {
        // In older Opera, version is after "Opera" or after "Version"
        browserName = 'Opera';
        // Ignored via go/ees005
        // eslint-disable-next-line no-cond-assign
        if ((verOffset = nAgt.indexOf('Version')) !== -1) browserVersion = nAgt.substring(verOffset + 8);
        else browserVersion = nAgt.substring(verOffset + 6);
    // Ignored via go/ees005
    // eslint-disable-next-line no-cond-assign
    } else if ((verOffset = nAgt.indexOf('MSIE')) !== -1) {
        // In MSIE, version is after "MSIE" in userAgent
        browserName = 'Microsoft Internet Explorer';
        browserVersion = nAgt.substring(verOffset + 5);
    // Ignored via go/ees005
    // eslint-disable-next-line no-cond-assign
    } else if ((verOffset = nAgt.indexOf('Chrome')) !== -1) {
        // In Chrome, version is after "Chrome"
        browserName = 'Chrome';
        browserVersion = nAgt.substring(verOffset + 7);
    // Ignored via go/ees005
    // eslint-disable-next-line no-cond-assign
    } else if ((verOffset = nAgt.indexOf('Safari')) !== -1) {
        // In Safari, version is after "Safari" or after "Version"
        browserName = 'Safari';
        // Ignored via go/ees005
        // eslint-disable-next-line no-cond-assign
        if ((verOffset = nAgt.indexOf('Version')) !== -1) browserVersion = nAgt.substring(verOffset + 8);
        else browserVersion = nAgt.substring(verOffset + 7);
    // Ignored via go/ees005
    // eslint-disable-next-line no-cond-assign
    } else if ((verOffset = nAgt.indexOf('Firefox')) !== -1) {
        // In Firefox, version is after "Firefox"
        browserName = 'Firefox';
        browserVersion = nAgt.substring(verOffset + 8);
    // Ignored via go/ees005
    // eslint-disable-next-line no-cond-assign
    // Ignored via go/ees005
    // eslint-disable-next-line no-cond-assign
    } else if ((nameOffset = nAgt.lastIndexOf(' ') + 1) < (verOffset = nAgt.lastIndexOf('/'))) {
        // In most other browsers, "name/version" is at the end of userAgent
        browserName = nAgt.substring(nameOffset, verOffset);
        browserVersion = nAgt.substring(verOffset + 1);
        if (browserName.toLowerCase() === browserName.toUpperCase()) browserName = navigator.appName;
    } else {
        browserName = navigator.appName;
        browserVersion = '' + parseFloat(navigator.appVersion);
    }
    // trim the versionStr string at semicolon/space if present
    // Ignored via go/ees005
    // eslint-disable-next-line no-cond-assign
    if ((index = browserVersion.indexOf(';')) !== -1) browserVersion = browserVersion.substring(0, index);
    // Ignored via go/ees005
    // eslint-disable-next-line no-cond-assign
    if ((index = browserVersion.indexOf(' ')) !== -1) browserVersion = browserVersion.substring(0, index);
    return `${browserName} ${browserVersion}`;
};
var $678a1d6347e818a9$export$2e2bcd8739ae039 = $678a1d6347e818a9$var$getBrowserInfo;


/**
 * Inspired from:
 * https://stackoverflow.com/questions/9514179/how-to-find-the-operating-system-version-using-javascript
 */ const $15021288aa91dfe1$var$getDeviceInfo = (nAgt, nVersion)=>{
    let os = '';
    let osVersion = '';
    const clientStrings = [
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        {
            s: 'Windows 3.11',
            r: /Win16/
        },
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        {
            s: 'Windows 95',
            r: /(Windows 95|Win95|Windows_95)/
        },
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        {
            s: 'Windows ME',
            r: /(Win 9x 4.90|Windows ME)/
        },
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        {
            s: 'Windows 98',
            r: /(Windows 98|Win98)/
        },
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        {
            s: 'Windows CE',
            r: /Windows CE/
        },
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        {
            s: 'Windows 2000',
            r: /(Windows NT 5.0|Windows 2000)/
        },
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        {
            s: 'Windows XP',
            r: /(Windows NT 5.1|Windows XP)/
        },
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        {
            s: 'Windows Server 2003',
            r: /Windows NT 5.2/
        },
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        {
            s: 'Windows Vista',
            r: /Windows NT 6.0/
        },
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        {
            s: 'Windows 7',
            r: /(Windows 7|Windows NT 6.1)/
        },
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        {
            s: 'Windows 8.1',
            r: /(Windows 8.1|Windows NT 6.3)/
        },
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        {
            s: 'Windows 8',
            r: /(Windows 8|Windows NT 6.2)/
        },
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        {
            s: 'Windows NT 4.0',
            r: /(Windows NT 4.0|WinNT4.0|WinNT|Windows NT)/
        },
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        {
            s: 'Android',
            r: /Android/
        },
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        {
            s: 'Open BSD',
            r: /OpenBSD/
        },
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        {
            s: 'Sun OS',
            r: /SunOS/
        },
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        {
            s: 'Linux',
            r: /(Linux|X11)/
        },
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        {
            s: 'iOS',
            r: /(iPhone|iPad|iPod)/
        },
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        {
            s: 'Mac OS X',
            r: /Mac OS X/
        },
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        {
            s: 'Mac OS',
            r: /(MacPPC|MacIntel|Mac_PowerPC|Macintosh)/
        },
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        {
            s: 'QNX',
            r: /QNX/
        },
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        {
            s: 'UNIX',
            r: /UNIX/
        },
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        {
            s: 'BeOS',
            r: /BeOS/
        },
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        {
            s: 'OS/2',
            r: /OS\/2/
        },
        {
            s: 'Search Bot',
            // Ignored via go/ees005
            // eslint-disable-next-line require-unicode-regexp
            r: /(nuhk|Googlebot|Yammybot|Openbot|Slurp|MSNBot|Ask Jeeves\/Teoma|ia_archiver)/
        }
    ];
    // eslint-disable-next-line guard-for-in
    for(const client in clientStrings){
        const clientObj = clientStrings[client];
        if (clientObj.r.test(nAgt)) {
            os = clientObj.s;
            break;
        }
    }
    let match;
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    if (/Windows/.test(os)) {
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        match = /Windows (.*)/.exec(os);
        osVersion = match && match[1];
        os = 'Windows';
    }
    switch(os){
        case 'Mac OS X':
            // Ignored via go/ees005
            // eslint-disable-next-line require-unicode-regexp
            match = /Mac OS X (10[\.\_\d]+)/.exec(nAgt);
            osVersion = match && match[1];
            break;
        case 'Android':
            // Ignored via go/ees005
            // eslint-disable-next-line require-unicode-regexp
            match = /Android ([\.\_\d]+)/.exec(nAgt);
            osVersion = match && match[1];
            break;
        case 'iOS':
            // Ignored via go/ees005
            // eslint-disable-next-line require-unicode-regexp
            match = /OS (\d+)_(\d+)_?(\d+)?/.exec(nVersion);
            osVersion = match && match[1] + '.' + match[2] + '.' + (match[3] || 0);
    }
    return `${os} ${osVersion}`;
};
var $15021288aa91dfe1$export$2e2bcd8739ae039 = $15021288aa91dfe1$var$getDeviceInfo;


const $477708b1f3fcf8d3$var$JIRA_ISSUE_COLLECTOR_URL = 'https://product-fabric.atlassian.net/s/d41d8cd98f00b204e9800998ecf8427e-T/-w0bwo4/b/14/e73395c53c3b10fde2303f4bf74ffbf6/_/download/batch/com.atlassian.jira.collector.plugin.jira-issue-collector-plugin:issuecollector-embededjs/com.atlassian.jira.collector.plugin.jira-issue-collector-plugin:issuecollector-embededjs.js?locale=en-US&collectorId=98644b9c';
const $477708b1f3fcf8d3$var$loadJiraCollectorDialogScript = (labels, packageName, coreVersion, packageVersion, sessionId, contentId, tabId)=>{
    // eslint-disable-next-line no-async-promise-executor, require-await
    return new Promise(async (resolve, reject)=>{
        if (window.jQuery) {
            window.ATL_JQ_PAGE_PROPS = {
                triggerFunction: (showCollectorDialog)=>{
                    if (typeof showCollectorDialog === 'function') resolve(showCollectorDialog);
                    else reject('Failed to initialize showCollectorDialog');
                },
                fieldValues: {
                    description: `Please describe the problem you're having or feature you'd like to see:\n\n\n`,
                    // 11711 is the field ID for the Feedback Labels field on Product Fabric.
                    // this is found by clicking "configure" on the field and inspecting the URL
                    customfield_11711: labels || [],
                    customfield_11712: `version: ${packageName}@${packageVersion} (${coreVersion})
              Browser: ${(0, $678a1d6347e818a9$export$2e2bcd8739ae039)(navigator.userAgent)}
              OS: ${(0, $15021288aa91dfe1$export$2e2bcd8739ae039)(navigator.userAgent, navigator.appVersion)}`
                },
                environment: {
                    'Editor Package': packageName,
                    'Editor Version': packageVersion,
                    'Editor Core Version': coreVersion,
                    sessionId: sessionId,
                    contentId: contentId,
                    tabId: tabId
                },
                priority: '1',
                components: '15306'
            };
            window.jQuery.ajax({
                url: $477708b1f3fcf8d3$var$JIRA_ISSUE_COLLECTOR_URL,
                type: 'get',
                cache: true,
                dataType: 'script'
            });
        } else reject('jQuery is not defined');
    });
};
var $477708b1f3fcf8d3$export$2e2bcd8739ae039 = $477708b1f3fcf8d3$var$loadJiraCollectorDialogScript;


let $ea53b8452ab0b839$var$showJiraCollectorDialog;
let $ea53b8452ab0b839$var$feedbackInfoHash;
let $ea53b8452ab0b839$var$defaultFeedbackInfo;
const $ea53b8452ab0b839$var$hashFeedbackInfo = (feedbackInfo)=>{
    const { product: product, packageName: packageName, packageVersion: packageVersion, labels: labels } = feedbackInfo;
    return [
        product,
        packageName,
        packageVersion,
        ...labels || []
    ].join('|');
};
const $ea53b8452ab0b839$export$432e2d318c18feaa = async (feedbackInfo)=>// eslint-disable-next-line no-async-promise-executor
    new Promise(async (resolve, reject)=>{
        const combinedFeedbackInfo = {
            product: 'n/a',
            labels: [],
            packageName: '',
            packageVersion: '',
            coreVersion: '',
            sessionId: '',
            contentId: '',
            tabId: '',
            ...$ea53b8452ab0b839$var$defaultFeedbackInfo,
            ...feedbackInfo
        };
        const newFeedbackInfoHash = $ea53b8452ab0b839$var$hashFeedbackInfo(combinedFeedbackInfo);
        if (!$ea53b8452ab0b839$var$showJiraCollectorDialog || $ea53b8452ab0b839$var$feedbackInfoHash !== newFeedbackInfoHash) try {
            $ea53b8452ab0b839$var$showJiraCollectorDialog = await (0, $477708b1f3fcf8d3$export$2e2bcd8739ae039)([
                combinedFeedbackInfo.product,
                ...combinedFeedbackInfo.labels
            ], combinedFeedbackInfo.packageName, combinedFeedbackInfo.coreVersion, combinedFeedbackInfo.packageVersion, combinedFeedbackInfo.sessionId, combinedFeedbackInfo.contentId, combinedFeedbackInfo.tabId);
            $ea53b8452ab0b839$var$feedbackInfoHash = newFeedbackInfoHash;
        } catch (err) {
            reject(err);
        }
        const timeoutId = window.setTimeout($ea53b8452ab0b839$var$showJiraCollectorDialog, 0);
        // Return the timoutId for consumers to call clearTimeout if they need to.
        resolve(timeoutId);
    });
const $ea53b8452ab0b839$export$1b6ac82b29dcc009 = ({ config: feedbackInfo, api: api })=>{
    $ea53b8452ab0b839$var$defaultFeedbackInfo = feedbackInfo ?? {};
    return {
        name: 'feedbackDialog',
        actions: {
            openFeedbackDialog: $ea53b8452ab0b839$export$432e2d318c18feaa
        },
        pluginsOptions: {
            quickInsert: ({ formatMessage: formatMessage })=>[
                    {
                        id: 'feedbackdialog',
                        title: formatMessage((0, $4HWgE.toolbarInsertBlockMessages).feedbackDialog),
                        description: formatMessage((0, $4HWgE.toolbarInsertBlockMessages).feedbackDialogDescription),
                        priority: 400,
                        keywords: [
                            'bug'
                        ],
                        icon: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $3pLGZ.IconFeedback), {}),
                        action (insert, state) {
                            const tr = insert('');
                            $ea53b8452ab0b839$export$432e2d318c18feaa(feedbackInfo);
                            api?.analytics?.actions.attachAnalyticsEvent({
                                action: (0, $d925B.ACTION).OPENED,
                                actionSubject: (0, $d925B.ACTION_SUBJECT).FEEDBACK_DIALOG,
                                attributes: {
                                    inputMethod: (0, $d925B.INPUT_METHOD).QUICK_INSERT
                                },
                                eventType: (0, $d925B.EVENT_TYPE).UI
                            })(tr);
                            return tr;
                        }
                    }
                ]
        }
    };
};
module.exports["feedbackDialogPlugin"] = $ea53b8452ab0b839$export$1b6ac82b29dcc009;

});

parcelRegister("kwFBr", function(module, exports) {

var $8m4tT = parcelRequire("8m4tT");


var $ks2lK = parcelRequire("ks2lK");

const $97c0b772b35946ae$export$d2ec7ab2b2a98746 = (state)=>{
    const { media: media } = state.schema.nodes;
    return state.selection instanceof (0, $ks2lK.NodeSelection) && state.selection.node.type === media;
};
const $97c0b772b35946ae$export$262e43a15b79aeb7 = (state)=>{
    const { mediaSingle: mediaSingle } = state.schema.nodes;
    const { $to: $to } = state.selection;
    if (mediaSingle) for(let d = $to.depth; d >= 0; d--){
        const index = $to.index(d);
        if ($to.node(d).canReplaceWith(index, index, mediaSingle)) return true;
    }
    return false;
};
const $97c0b772b35946ae$export$4747cb76ebf8d6df = (url, schema)=>{
    const { media: media, mediaSingle: mediaSingle } = schema.nodes;
    if (!media || !mediaSingle) return null;
    const mediaNode = media.createChecked({
        type: 'external',
        url: url
    });
    return mediaSingle.createChecked({}, mediaNode);
};





const $efe8c38ed286d843$export$77b371d6becc8882 = new (0, $ks2lK.PluginKey)('imageUploadPlugin');


const $c8b9f63a3af17b0e$var$imageUploadAction = (tr, action)=>{
    return tr.setMeta((0, $efe8c38ed286d843$export$77b371d6becc8882), action);
};
const $c8b9f63a3af17b0e$export$bacf5b3f68174df = (event)=>(tr)=>$c8b9f63a3af17b0e$var$imageUploadAction(tr, {
            name: 'START_UPLOAD',
            event: event
        });



const $916bc99ad638690d$export$d978a1cf00cd351b = (options)=>(state, dispatch)=>{
        const pluginState = (0, $efe8c38ed286d843$export$77b371d6becc8882).getState(state);
        if (!pluginState?.enabled || !options.src) return false;
        const mediaNode = (0, $97c0b772b35946ae$export$4747cb76ebf8d6df)(options.src, state.schema);
        if (!mediaNode) return false;
        if (dispatch) dispatch((0, $8m4tT.safeInsert)(mediaNode, state.selection.$to.pos)(state.tr).scrollIntoView());
        return true;
    };
const $916bc99ad638690d$export$41b18c224f9e33da = (event)=>(state, dispatch)=>{
        const pluginState = (0, $efe8c38ed286d843$export$77b371d6becc8882).getState(state);
        if (pluginState && !pluginState.enabled) return false;
        if (dispatch) dispatch((0, $c8b9f63a3af17b0e$export$bacf5b3f68174df)(event)(state.tr));
        return true;
    };


const $10b92a36bb7a5950$export$62f5bb5681401150 = (uploadHandlerReference)=>{
    return (state, dispatch)=>{
        if (!uploadHandlerReference.current) return false;
        uploadHandlerReference.current(undefined, (options)=>{
            (0, $916bc99ad638690d$export$d978a1cf00cd351b)(options)(state, dispatch);
        });
        return true;
    };
};



var $1S4f7 = parcelRequire("1S4f7");


var $l03WE = parcelRequire("l03WE");


var $aIMBk = parcelRequire("aIMBk");


function $dafe10b6764a68aa$export$568a7ed6897c4817(schema, featureFlags) {
    if (!schema.nodes.media || !schema.nodes.mediaSingle) return;
    // ![something](link) should convert to an image
    // eslint-disable-next-line require-unicode-regexp
    const imageRule = (0, $l03WE.createRule)(/!\[(.*)\]\((\S+)\)$/, (state, match, start, end)=>{
        const { schema: schema } = state;
        const attrs = {
            src: match[2],
            alt: match[1]
        };
        const node = (0, $97c0b772b35946ae$export$4747cb76ebf8d6df)(attrs.src, schema);
        if (node) return state.tr.replaceWith(start, end, node);
        return null;
    });
    return new (0, $1S4f7.SafePlugin)((0, $aIMBk.createPlugin)('image-upload', [
        imageRule
    ]));
}
var $dafe10b6764a68aa$export$2e2bcd8739ae039 = $dafe10b6764a68aa$export$568a7ed6897c4817;



var $8gdgt = parcelRequire("8gdgt");




// Typeguard Function
const $e59683bbab878740$export$5694727fbed080b4 = (event)=>'clipboardData' in event;


// Typeguard Function
const $f38dff49b31c8aeb$export$fd4eab91eb7545c8 = (event)=>'dataTransfer' in event;
function $f38dff49b31c8aeb$export$6ca76751d014281f(rawEvent) {
    const e = rawEvent;
    if (!e.dataTransfer) return false;
    return Array.prototype.slice.call(e.dataTransfer.types).indexOf('Files') !== -1;
}





/**
 * Microsoft Office includes a screenshot image when copying text content.
 *
 * This function determines whether or not we can ignore the image if it
 * came from MS Office. We do this by checking for
 *
 * - plain text
 * - HTML text which includes the MS Office namespace
 * - the number of files and the file name/type
 *
 * It is easy to manually verify this using by using Office on Mac
 * (or Excel if on Windows) and pasting into
 * https://evercoder.github.io/clipboard-inspector/
 *
 * Note: image content in Word is stored in the `text/html` portion
 * of the clipboard, not under `files` attachment like the screenshot.
 *
 * @returns boolean True if the paste event contains a screenshot from MS Office
 */ const $8c64761772976f4f$var$hasScreenshotImageFromMSOffice = (ev)=>{
    const { clipboardData: clipboardData } = ev;
    if (!clipboardData || clipboardData.files.length !== 1) return false;
    const textPlain = !!clipboardData.getData('text/plain');
    const textHtml = clipboardData.getData('text/html');
    const isOfficeXMLNamespace = textHtml.includes('urn:schemas-microsoft-com:office:office');
    const file = clipboardData.files[0];
    const isImagePNG = file.type === 'image/png' && file.name === 'image.png';
    return isImagePNG && textPlain && isOfficeXMLNamespace;
};
const $8c64761772976f4f$var$createReferenceEventFromEvent = (event)=>{
    if (!(0, $f38dff49b31c8aeb$export$fd4eab91eb7545c8)(event) && !(0, $e59683bbab878740$export$5694727fbed080b4)(event)) return null;
    // Get files list and early exit if files is undefined
    const files = (0, $f38dff49b31c8aeb$export$fd4eab91eb7545c8)(event) ? event.dataTransfer?.files : event.clipboardData?.files;
    if (!files) return null;
    // Convert filelist into an array
    const filesArray = Array.from(files);
    // Creating a new DataTransfer object should remove any mutation that could be possible from the original event
    const dataTransfer = filesArray.reduce((acc, value)=>{
        acc.items.add(value);
        return acc;
    }, new DataTransfer());
    return {
        type: (0, $f38dff49b31c8aeb$export$fd4eab91eb7545c8)(event) ? 'drop' : 'paste',
        ...(0, $f38dff49b31c8aeb$export$fd4eab91eb7545c8)(event) && {
            dataTransfer: dataTransfer
        },
        ...(0, $e59683bbab878740$export$5694727fbed080b4)(event) && {
            clipboardData: dataTransfer
        }
    };
};
const $8c64761772976f4f$var$createDOMHandler = (pred, _eventName, uploadHandlerReference)=>(view, event)=>{
        if (!pred(event)) return false;
        const shouldUpload = !$8c64761772976f4f$var$hasScreenshotImageFromMSOffice(event);
        const referenceEvent = $8c64761772976f4f$var$createReferenceEventFromEvent(event);
        if (shouldUpload && referenceEvent) {
            event.preventDefault();
            event.stopPropagation();
            // Insert external image into document
            if (uploadHandlerReference.current) uploadHandlerReference.current(referenceEvent, (options)=>{
                (0, $916bc99ad638690d$export$d978a1cf00cd351b)(options)(view.state, view.dispatch);
            });
            // Start image upload
            (0, $916bc99ad638690d$export$41b18c224f9e33da)(referenceEvent)(view.state, view.dispatch);
        }
        return shouldUpload;
    };
const $8c64761772976f4f$var$getNewActiveUpload = (tr, pluginState)=>{
    const meta = tr.getMeta((0, $efe8c38ed286d843$export$77b371d6becc8882));
    if (meta && meta.name === 'START_UPLOAD') return {
        event: meta.event
    };
    return pluginState.activeUpload;
};
const $8c64761772976f4f$export$ae829ec7b2625219 = (uploadHandlerReference)=>({ dispatch: dispatch, providerFactory: providerFactory })=>{
        return new (0, $1S4f7.SafePlugin)({
            state: {
                init (_config, state) {
                    return {
                        active: false,
                        enabled: (0, $97c0b772b35946ae$export$262e43a15b79aeb7)(state),
                        hidden: !state.schema.nodes.media || !state.schema.nodes.mediaSingle
                    };
                },
                apply (tr, pluginState, _oldState, newState) {
                    const newActive = (0, $97c0b772b35946ae$export$d2ec7ab2b2a98746)(newState);
                    const newEnabled = (0, $97c0b772b35946ae$export$262e43a15b79aeb7)(newState);
                    const newActiveUpload = $8c64761772976f4f$var$getNewActiveUpload(tr, pluginState);
                    if (newActive !== pluginState.active || newEnabled !== pluginState.enabled || newActiveUpload !== pluginState.activeUpload) {
                        const newPluginState = {
                            ...pluginState,
                            active: newActive,
                            enabled: newEnabled,
                            activeUpload: newActiveUpload
                        };
                        dispatch((0, $efe8c38ed286d843$export$77b371d6becc8882), newPluginState);
                        return newPluginState;
                    }
                    return pluginState;
                }
            },
            key: (0, $efe8c38ed286d843$export$77b371d6becc8882),
            view: ()=>{
                const handleProvider = async (name, provider)=>{
                    if (name !== 'imageUploadProvider' || !provider) return;
                    try {
                        const imageUploadProvider = await provider;
                        uploadHandlerReference.current = imageUploadProvider;
                    } catch (e) {
                        uploadHandlerReference.current = null;
                    }
                };
                providerFactory.subscribe('imageUploadProvider', handleProvider);
                return {
                    destroy () {
                        uploadHandlerReference.current = null;
                        providerFactory.unsubscribe('imageUploadProvider', handleProvider);
                    }
                };
            },
            props: {
                handleDOMEvents: {
                    drop: $8c64761772976f4f$var$createDOMHandler((0, $f38dff49b31c8aeb$export$6ca76751d014281f), 'atlassian.editor.image.drop', uploadHandlerReference),
                    paste: $8c64761772976f4f$var$createDOMHandler((event)=>(0, $8gdgt.isPastedFile)(event), 'atlassian.editor.image.paste', uploadHandlerReference)
                }
            }
        });
    };



const $57ceba8706161d84$export$e3bfb926c9700157 = ()=>{
    const uploadHandlerReference = {
        current: null
    };
    return {
        name: 'imageUpload',
        getSharedState (editorState) {
            if (!editorState) return undefined;
            return (0, $efe8c38ed286d843$export$77b371d6becc8882).getState(editorState);
        },
        actions: {
            startUpload: ()=>(0, $10b92a36bb7a5950$export$62f5bb5681401150)(uploadHandlerReference)
        },
        pmPlugins () {
            return [
                {
                    name: 'imageUpload',
                    plugin: (0, $8c64761772976f4f$export$ae829ec7b2625219)(uploadHandlerReference)
                },
                {
                    name: 'imageUploadInputRule',
                    plugin: ({ schema: schema, featureFlags: featureFlags })=>(0, $dafe10b6764a68aa$export$2e2bcd8739ae039)(schema, featureFlags)
                }
            ];
        }
    };
};
module.exports["imageUploadPlugin"] = $57ceba8706161d84$export$e3bfb926c9700157;

});

parcelRegister("7IUDA", function(module, exports) {

var $iLaQ6 = parcelRequire("iLaQ6");


var $2eY6H = parcelRequire("2eY6H");

var $aXG5V = parcelRequire("aXG5V");

const $59f8937862012268$export$28ee9acdd4691fa9 = 'override-document';
class $59f8937862012268$export$d790696cf3da3aa0 extends (0, $2eY6H.Step) {
    apply(doc) {
        this.oldDocumentSize = doc.content.size;
        return (0, $aXG5V.StepResult).ok(this.nextDocument);
    }
    map() {
        return new $59f8937862012268$export$d790696cf3da3aa0({
            nextDocument: this.nextDocument,
            inverted: this.inverted
        });
    }
    getMap() {
        if (!this.nextDocument || !this.oldDocumentSize) return new (0, $aXG5V.StepMap)([
            0,
            0,
            0
        ]);
        const oldSize = this.oldDocumentSize;
        const nextDocumentSize = this.nextDocument.content.size;
        return new (0, $aXG5V.StepMap)([
            0,
            oldSize,
            nextDocumentSize
        ]);
    }
    invert(doc) {
        return new $59f8937862012268$export$d790696cf3da3aa0({
            nextDocument: doc,
            inverted: true
        });
    }
    toJSON() {
        return {
            stepType: $59f8937862012268$export$28ee9acdd4691fa9,
            inverted: this.inverted,
            nextDocument: this.nextDocument.toJSON()
        };
    }
    static fromJSON(schema, json) {
        if (!json || json.stepType !== $59f8937862012268$export$28ee9acdd4691fa9) throw new RangeError('Invalid overrideDocument step OverrideDocumentStep.fromJSON');
        return new $59f8937862012268$export$d790696cf3da3aa0({
            inverted: json.inverted,
            nextDocument: schema.nodeFromJSON(json.nextDocument)
        });
    }
    constructor(opts){
        super();
        (0, $iLaQ6.default)(this, "inverted", false);
        (0, $iLaQ6.default)(this, "oldDocumentSize", 0);
        const { inverted: inverted, nextDocument: nextDocument } = opts;
        if (nextDocument.type.name !== 'doc') throw new Error('nextDocument should be the entire prosemirror doc node and not only its content.');
        this.nextDocument = nextDocument;
        this.inverted = Boolean(inverted);
    }
}
(0, $2eY6H.Step).jsonID($59f8937862012268$export$28ee9acdd4691fa9, $59f8937862012268$export$d790696cf3da3aa0);
module.exports["OverrideDocumentStep"] = $59f8937862012268$export$d790696cf3da3aa0;

});

parcelRegister("l1bBg", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::527f33e0573e8027a3e6df8a9b12f86d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f4d2b07911d6a9af$var$_react = $f4d2b07911d6a9af$var$_interopRequireDefault((parcelRequire("42omo")));

var $f4d2b07911d6a9af$var$_baseNew = $f4d2b07911d6a9af$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $f4d2b07911d6a9af$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "BlockSynced".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for syncing content blocks in Editor experiences.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f4d2b07911d6a9af$var$BlockSyncedIcon = (props)=>/*#__PURE__*/ $f4d2b07911d6a9af$var$_react.default.createElement($f4d2b07911d6a9af$var$_baseNew.default, Object.assign({
        name: "BlockSyncedIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M13.5 3a.5.5 0 0 0-.5-.5H3a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h3V15H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v2h-1.5z"/><path fill="currentcolor" d="M14.9 8.71a3.75 3.75 0 0 1 0 5.303l-.024.026.439.146a.75.75 0 0 1-.13 1.454l-2.476.354a.75.75 0 0 1-.848-.849l.353-2.474.029-.125a.75.75 0 0 1 1.425-.006l.147.44.025-.026a2.25 2.25 0 0 0 0-3.183l-.707-.707 1.06-1.06zm-3.818-1.98a.75.75 0 0 1 .85.849l-.354 2.475a.75.75 0 0 1-1.454.13l-.147-.44-.025.026a2.25 2.25 0 0 0 0 3.183l.707.707-1.06 1.06-.708-.707a3.75 3.75 0 0 1 0-5.303l.026-.026-.44-.146a.75.75 0 0 1 .13-1.454z"/>`
    }, props));
$f4d2b07911d6a9af$var$BlockSyncedIcon.displayName = 'BlockSyncedIcon';
var $f4d2b07911d6a9af$var$_default = module.exports.default = $f4d2b07911d6a9af$var$BlockSyncedIcon;

});


//# sourceMappingURL=FullPageEditorComponent.94494c5a.js.map
